import * as React from "react";
import { addHours } from "date-fns";

import {
  ITeacher,
  ILesson,
  IActiveLearningLesson,
  IActiveLearningMaterial,
  IActiveLearningMaterialLessons,
  IActiveLearningMaterialLessonsData,
  IActiveLearningStudentAnswers,
  IActiveLearningKlassStudentAnswers,
  IActiveLearningTheme,
  IActiveLearningStoryBoard,
  IActiveLearningMaterialAnswers,
  ITeachingMaterial,
  IStudent,
  IAssessmentStudent,
  IGroup,
  IClass,
  IClassWithStudents,
  IAnswer,
  IAnswersByClass,
  ITeachingMaterialAnswerSummary,
  IAnswerComment,
  IPackage,
  ISurveyAnswers,
  IDetailsSurvey,
  ILessonByTeachingMaterial,
  ILessonCSV,
  ISchoolCountAnswers,
  ISchoolGoals,
  IAssessmentTeacher,
  IAssessment,
  IAssessmentDistribution,
  IAssessmentAvgScores,
  IAnswersFromOtherSchoolByClass,
  IIssue,
  IAssessmentCSV,
  IDistribution,
  IPortfolio,
  ISimpleTeachingMaterial,
  ILoginResponse,
  ILoginMFAResponse,
  IAllDistributions,
  IAssessmentAnswer,
  IClassScores,
  IReferenceScores,
  ICompletionStatuses,
  ITeacherLessonRetrospectives,
  OnePagePortfolioAssessment,
  OnePagePortfolioAssessments,
  ReferenceIssues,
  ITeachingHintsIntroductions,
  ITeachingHintsGroupWorks,
  ITeacherSurvey,
  ISubmitTeacherSurvey,
  IOnePagePortfolioAssessmentCSVData,
  LessonVideoChapters,
} from "../state";

export const defaultPath = "/";
export const prefixPath = "/te";
export const homePath = `/home`;
export const loginPath = `/login`;
export const authenticationPath = `/authentication`;
export const guidelinePath = `/guideline`;
export const activeLearningGuidelinePath = `/active_learning_guideline`;
export const activeLearningProjectionPath = `/active_learning_projection`;
export const activeLearningLessonPath = `/active_learning_lessons`;
export const activeLearningThemesPath = `/active_learning_themes`;
export const activeLearningStoryBookPath = `/active_learning_story_board`;
export const projectionPath = `/projection`;
export const videoLessonPath = `/video_lesson`;
export const selectTextbookPath = `/select_textbook`;
export const textbookPath = `/textbook`;
export const selectDataPath = `/select_data`;
export const activeLearningTextbookPath = `/active_learning_textbook`;
export const chooseTextbookPath = `/choose`;
export const notFoundPath = `/not-found`;
export const updateTeacherPasswordPath = `/update_teacher_password`;
export const forgotPasswordPath = `/forgot_password`;
export const resetPasswordCompletedPath = `/reset_password_completed`;
export const classDataPath = `/data`;
export const activeLearningClassDataPath = `/active_learning_data`;
export const assessmentDescriptionPath = `/assessment_description`;
export const assessmentByClassPath = `/assessment_by_class`;
export const assessmentByGradePath = `/assessment_by_grade`;
export const assessmentPath = `/assessments`;
export const allAssessmentDistributionPath = `/all_assessment_distribution`;
export const manualPath = `/manual`;

export const CLEAR_SUCCESS_MESSAGE = "CLEAR_SUCCESS_MESSAGE";
export const CLEAR_ERROR_MESSAGE = "CLEAR_ERROR_MESSAGE";
export const CLEAR_OTT = "CLEAR_OTT";
export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const VERIFY_MFA = "VERIFY_MFA";
export const VERIFY_MFA_SUCCESS = "VERIFY_MFA_SUCCESS";
export const VERIFY_MFA_FAILURE = "VERIFY_MFA_FAILURE";
export const LOGOUT = "LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";
export const FETCH_INITIAL_DATA = "FETCH_INITIAL_DATA";
export const FETCH_INITIAL_DATA_SUCCESS = "FETCH_INITIAL_DATA_SUCCESS";
export const FETCH_INITIAL_DATA_FAILURE = "FETCH_INITIAL_DATA_FAILURE";
export const FETCH_SCHOOL_GOALS = "FETCH_SCHOOL_GOALS";
export const FETCH_SCHOOL_GOALS_SUCCESS = "FETCH_SCHOOL_GOALS_SUCCESS";
export const FETCH_COUNT_ANSWERS = "FETCH_COUNT_ANSWERS";
export const FETCH_COUNT_ANSWERS_SUCCESS = "FETCH_COUNT_ANSWERS_SUCCESS";
export const FETCH_TEACHING_MATERIALS = "FETCH_TEACHING_MATERIALS";
export const FETCH_TEACHING_MATERIALS_SUCCESS =
  "FETCH_TEACHING_MATERIALS_SUCCESS";
export const FETCH_TEACHING_MATERIALS_FAILURE =
  "FETCH_TEACHING_MATERIALS_FAILURE";
export const FETCH_ACTIVE_LEARNING_MATERIALS =
  "FETCH_ACTIVE_LEARNING_MATERIALS";
export const FETCH_ACTIVE_LEARNING_MATERIALS_SUCCESS =
  "FETCH_ACTIVE_LEARNING_MATERIALS_SUCCESS";
export const FETCH_ACTIVE_LEARNING_MATERIAL_LESSONS =
  "FETCH_ACTIVE_LEARNING_MATERIAL_LESSONS";
export const FETCH_ACTIVE_LEARNING_MATERIAL_LESSONS_SUCCESS =
  "FETCH_ACTIVE_LEARNING_MATERIAL_LESSONS_SUCCESS";
export const FETCH_ACTIVE_LEARNING_MATERIAL_LESSONS_DATA =
  "FETCH_ACTIVE_LEARNING_MATERIAL_LESSONS_DATA";
export const FETCH_ACTIVE_LEARNING_MATERIAL_LESSONS_DATA_SUCCESS =
  "FETCH_ACTIVE_LEARNING_MATERIAL_LESSONS_DATA_SUCCESS";
export const FETCH_ACTIVE_LEARNING_MATERIALS_FAILURE =
  "FETCH_ACTIVE_LEARNING_MATERIALS_FAILURE";
export const FETCH_ACTIVE_LEARNING_ANSWERS = "FETCH_ACTIVE_LEARNING_ANSWERS";
export const FETCH_ACTIVE_LEARNING_ANSWERS_SUCCESS =
  "FETCH_ACTIVE_LEARNING_ANSWERS_SUCCESS";
export const FETCH_ACTIVE_LEARNING_STUDENT_ANSWERS =
  "FETCH_ACTIVE_LEARNING_STUDENT_ANSWERS";
export const FETCH_ACTIVE_LEARNING_STUDENT_ANSWERS_SUCCESS =
  "FETCH_ACTIVE_LEARNING_STUDENT_ANSWERS_SUCCESS";
export const FETCH_ACTIVE_LEARNING_STUDENT_ANSWERS_FAILURE =
  "FETCH_ACTIVE_LEARNING_STUDENT_ANSWERS_FAILURE";
export const FETCH_ACTIVE_LEARNING_THEMES = "FETCH_ACTIVE_LEARNING_THEMES";
export const FETCH_ACTIVE_LEARNING_THEMES_SUCCESS =
  "FETCH_ACTIVE_LEARNING_THEMES_SUCCESS";
export const FETCH_ACTIVE_LEARNING_THEMES_FAILURE =
  "FETCH_ACTIVE_LEARNING_THEMES_FAILURE";
export const CLEAR_TEACHING_MATERIALS = "CLEAR_TEACHING_MATERIALS";
export const FETCH_SIMPLE_TEACHING_MATERIALS =
  "FETCH_SIMPLE_TEACHING_MATERIALS";
export const FETCH_SIMPLE_TEACHING_MATERIALS_SUCCESS =
  "FETCH_SIMPLE_TEACHING_MATERIALS_SUCCESS";
export const FETCH_SIMPLE_TEACHING_MATERIALS_FAILURE =
  "FETCH_SIMPLE_TEACHING_MATERIALS_FAILURE";
export const CREATE_TEACHING_MATERIAL_VIEW_LOG =
  "CREATE_TEACHING_MATERIAL_VIEW_LOG";
export const CREATE_TEACHING_MATERIAL_VIEW_LOG_SUCCESS =
  "CREATE_TEACHING_MATERIAL_VIEW_LOG_SUCCESS";
export const CREATE_VIDEO_CHAPTER_VIEW_LOG = "CREATE_VIDEO_CHAPTER_VIEW_LOG";
export const CREATE_VIDEO_CHAPTER_VIEW_LOG_SUCCESS =
  "CREATE_VIDEO_CHAPTER_VIEW_LOG_SUCCESS";
export const FETCH_LESSONS = "FETCH_LESSONS";
export const FETCH_LESSONS_SUCCESS = "FETCH_LESSONS_SUCCESS";
export const FETCH_LESSONS_FAILURE = "FETCH_LESSONS_FAILURE";
export const FETCH_LESSON = "FETCH_LESSON";
export const FETCH_LESSON_SUCCESS = "FETCH_LESSON_SUCCESS";
export const FETCH_LESSON_FAILURE = "FETCH_LESSON_FAILURE";
export const FETCH_LESSON_VIDEO_CHAPTERS = "FETCH_LESSON_VIDEO_CHAPTERS";
export const FETCH_LESSON_VIDEO_CHAPTERS_SUCCESS =
  "FETCH_LESSON_VIDEO_CHAPTERS_SUCCESS";
export const FETCH_LESSON_VIDEO_CHAPTERS_FAILURE =
  "FETCH_LESSON_VIDEO_CHAPTERS_FAILURE";
export const FETCH_LESSON_ACTIVE_LEARNING = "FETCH_LESSON_ACTIVE_LEARNING";
export const FETCH_LESSON_ACTIVE_LEARNING_SUCCESS =
  "FETCH_LESSON_ACTIVE_LEARNING_SUCCESS";
export const FETCH_LESSON_ACTIVE_LEARNING_FAILURE =
  "FETCH_LESSON_ACTIVE_LEARNING_FAILURE";
export const CREATE_GROUP = "CREATE_GROUP";
export const CREATE_GROUP_SUCCESS = "CREATE_GROUP_SUCCESS";
export const CREATE_GROUP_FAILURE = "CREATE_GROUP_FAILURE";
export const BULK_CREATE_GROUPS = "BULK_CREATE_GROUPS";
export const BULK_CREATE_GROUPS_SUCCESS = "BULK_CREATE_GROUPS_SUCCESS";
export const BULK_CREATE_GROUPS_FAILURE = "BULK_CREATE_GROUPS_FAILURE";
export const UPDATE_GROUP = "UPDATE_GROUP";
export const UPDATE_GROUP_SUCCESS = "UPDATE_GROUP_SUCCESS";
export const UPDATE_GROUP_FAILURE = "UPDATE_GROUP_FAILURE";
export const FETCH_STUDENTS = "FETCH_STUDENTS";
export const FETCH_STUDENTS_SUCCESS = "FETCH_STUDENTS_SUCCESS";
export const FETCH_STUDENTS_FAILURE = "FETCH_STUDENTS_FAILURE";
export const FETCH_ASSESSMENT_STUDENTS = "FETCH_ASSESSMENT_STUDENTS";
export const FETCH_ASSESSMENT_STUDENTS_SUCCESS =
  "FETCH_ASSESSMENT_STUDENTS_SUCCESS";
export const FETCH_ASSESSMENT_STUDENTS_FAILURE =
  "FETCH_ASSESSMENT_STUDENTS_FAILURE";
export const FETCH_ACTIVE_LEARNING_STORY_BOARD =
  "FETCH_ACTIVE_LEARNING_STORY_BOARD";
export const FETCH_ACTIVE_LEARNING_STORY_BOARD_SUCCESS =
  "FETCH_ACTIVE_LEARNING_STORY_BOARD_SUCCESS";
export const FETCH_ACTIVE_LEARNING_STORY_BOARD_FAILURE =
  "FETCH_ACTIVE_LEARNING_STORY_BOARD_FAILURE";
export const SEND_FEEDBACK_COMMENT = "SEND_FEEDBACK_COMMENT";
export const SEND_FEEDBACK_COMMENT_SUCCESS = "SEND_FEEDBACK_COMMENT_SUCCESS";
export const SEND_FEEDBACK_COMMENT_FAILURE = "SEND_FEEDBACK_COMMENT_FAILURE";
export const FETCH_GROUPS = "FETCH_GROUPS";
export const FETCH_GROUPS_SUCCESS = "FETCH_GROUPS_SUCCESS";
export const FETCH_GROUPS_FAILURE = "FETCH_GROUPS_FAILURE";
export const FETCH_CLASSES = "FETCH_CLASSES";
export const FETCH_CLASSES_SUCCESS = "FETCH_CLASSES_SUCCESS";
export const FETCH_CLASSES_FAILURE = "FETCH_CLASSES_FAILURE";
export const FETCH_CLASSES_BY_GRADE = "FETCH_CLASSES_BY_GRADE";
export const FETCH_CLASSES_BY_GRADE_SUCCESS = "FETCH_CLASSES_BY_GRADE_SUCCESS";
export const FETCH_ACTIVE_LEARNING_MATERIAL_ANSWERS =
  "FETCH_ACTIVE_LEARNING_MATERIAL_ANSWERS";
export const FETCH_ACTIVE_LEARNING_MATERIAL_ANSWERS_SUCCESS =
  "FETCH_ACTIVE_LEARNING_MATERIAL_ANSWERS_SUCCESS";
export const FETCH_KLASS_IDS_WITH_ACTIVE_LEARNING_MATERIALS =
  "FETCH_KLASS_IDS_WITH_ACTIVE_LEARNING_MATERIALS";
export const FETCH_KLASS_IDS_WITH_ACTIVE_LEARNING_MATERIALS_SUCCESS =
  "FETCH_KLASS_IDS_WITH_ACTIVE_LEARNING_MATERIALS_SUCCESS";
export const FETCH_ANSWERS = "FETCH_ANSWERS";
export const FETCH_ANSWERS_SUCCESS = "FETCH_ANSWERS_SUCCESS";
export const FETCH_ANSWERS_FAILURE = "FETCH_ANSWERS_FAILURE";
export const FETCH_ANSWERS_FROM_OTHER_SCHOOLS =
  "FETCH_ANSWERS_FROM_OTHER_SCHOOLS";
export const FETCH_ANSWERS_FROM_OTHER_SCHOOLS_SUCCESS =
  "FETCH_ANSWERS_FROM_OTHER_SCHOOLS_SUCCESS";
export const FETCH_ANSWERS_FROM_OTHER_SCHOOLS_FAILURE =
  "FETCH_ANSWERS_FROM_OTHER_SCHOOLS_FAILURE";
export const FETCH_ANSWER_SUMMARIES = "FETCH_ANSWER_SUMMARIES";
export const FETCH_ANSWER_SUMMARIES_SUCCESS = "FETCH_ANSWER_SUMMARIES_SUCCESS";
export const FETCH_ANSWER_SUMMARIES_FAILURE = "FETCH_ANSWER_SUMMARIES_FAILURE";
export const CREATE_COMMENT = "CREATE_COMMENT";
export const CREATE_COMMENT_SUCCESS = "CREATE_COMMENT_SUCCESS";
export const CREATE_COMMENT_FAILURE = "CREATE_COMMENT_FAILURE";
export const PUBLISH_TEACHING_MATERIAL = "PUBLISH_TEACHING_MATERIAL";
export const PUBLISH_TEACHING_MATERIAL_SUCCESS =
  "PUBLISH_TEACHING_MATERIAL_SUCCESS";
export const PUBLISH_TEACHING_MATERIAL_FAILURE =
  "PUBLISH_TEACHING_MATERIAL_FAILURE";
export const UNPUBLISH_TEACHING_MATERIAL = "UNPUBLISH_TEACHING_MATERIAL";
export const UNPUBLISH_TEACHING_MATERIAL_SUCCESS =
  "UNPUBLISH_TEACHING_MATERIAL_SUCCESS";
export const UNPUBLISH_TEACHING_MATERIAL_FAILURE =
  "UNPUBLISH_TEACHING_MATERIAL_FAILURE";
export const PUBLISH_LESSON = "PUBLISH_LESSON";
export const PUBLISH_LESSON_SUCCESS = "PUBLISH_LESSON_SUCCESS";
export const PUBLISH_LESSON_FAILURE = "PUBLISH_LESSON_FAILURE";
export const UNPUBLISH_LESSON = "UNPUBLISH_LESSON";
export const UNPUBLISH_LESSON_FAILURE = "UNPUBLISH_LESSON_FAILURE";
export const UNPUBLISH_LESSON_SUCCESS = "UNPUBLISH_LESSON_SUCCESS";
export const NAME_OPENED = "NAME_OPENED";
export const NAME_OPENED_SUCCESS = "NAME_OPENED_SUCCESS";
export const NAME_OPENED_FAILURE = "NAME_OPENED_FAILURE";
export const NAME_CLOSED = "NAME_CLOSED";
export const NAME_CLOSED_SUCCESS = "NAME_CLOSED_SUCCESS";
export const NAME_CLOSED_FAILURE = "NAME_CLOSED_FAILURE";
export const ANSWER_OPENED = "ANSWER_OPENED";
export const ANSWER_OPENED_SUCCESS = "ANSWER_OPENED_SUCCESS";
export const ANSWER_OPENED_FAILURE = "ANSWER_OPENED_FAILURE";
export const ANSWER_CLOSED = "ANSWER_CLOSED";
export const ANSWER_CLOSED_SUCCESS = "ANSWER_CLOSED_SUCCESS";
export const ANSWER_CLOSED_FAILURE = "ANSWER_CLOSED_FAILURE";
export const DELETE_GROUP = "DELETE_GROUP";
export const DELETE_GROUP_SUCCESS = "DELETE_GROUP_SUCCESS";
export const DELETE_GROUP_FAILURE = "DELETE_GROUP_FAILURE";

export const CLEAR_TEMPORARY_TOKEN = "CLEAR_TEMPORARY_TOKEN";
export const FETCH_TEACHING_MATERIAL = "FETCH_TEACHING_MATERIAL";
export const FETCH_TEACHING_MATERIAL_SUCCESS =
  "FETCH_TEACHING_MATERIAL_SUCCESS";
export const FETCH_TEACHING_MATERIAL_FAILURE =
  "FETCH_TEACHING_MATERIAL_FAILURE";
export const UPDATE_TEACHER_PASSWORD = "UPDATE_TEACHER_PASSWORD";
export const UPDATE_TEACHER_PASSWORD_SUCCESS =
  "UPDATE_TEACHER_PASSWORD_SUCCESS";
export const UPDATE_TEACHER_PASSWORD_FAILURE =
  "UPDATE_TEACHER_PASSWORD_FAILURE";
export const RESET_TEACHER_PASSWORD = "RESET_TEACHER_PASSWORD";
export const RESET_TEACHER_PASSWORD_SUCCESS = "RESET_TEACHER_PASSWORD_SUCCESS";
export const RESET_TEACHER_PASSWORD_FAILURE = "RESET_TEACHER_PASSWORD_FAILURE";
export const UPDATE_COMMENT = "UPDATE_COMMENT";
export const DELETE_COMMENT = "DELETE_COMMENT";
export const UPDATE_COMMENT_SUCCESS = "UPDATE_COMMENT_SUCCESS";
export const DELETE_COMMENT_SUCCESS = "DELETE_COMMENT_SUCCESS";
export const FETCH_PACKAGES = "FETCH_PACKAGES";
export const FETCH_PACKAGES_SUCCESS = "FETCH_PACKAGES_SUCCESS";
export const FETCH_PACKAGES_FAILURE = "FETCH_PACKAGES_FAILURE";
export const FETCH_SURVEY_ANSWERS = "FETCH_SURVEY_ANSWERS";
export const FETCH_SURVEY_ANSWERS_SUCCESS = "FETCH_SURVEY_ANSWERS_SUCCESS";
export const FETCH_SURVEY_ANSWERS_FAILURE = "FETCH_SURVEY_ANSWERS_FAILURE";
export const FETCH_DETAILS_SURVEY = "FETCH_DETAILS_SURVEY";
export const FETCH_DETAILS_SURVEY_SUCCESS = "FETCH_DETAILS_SURVEY_SUCCESS";
export const FETCH_DETAILS_SURVEY_FAILURE = "FETCH_DETAILS_SURVEY_FAILURE";
export const TOGGLE_COMMENT = "TOGGLE_COMMENT";
export const TOGGLE_COMMENT_SUCCESS = "TOGGLE_COMMENT_SUCCESS";
export const TOGGLE_COMMENT_FAILURE = "TOGGLE_COMMENT_FAILURE";
export const FETCH_LIST_LESSONS = "FETCH_LIST_LESSONS";
export const FETCH_LIST_LESSONS_SUCCESS = "FETCH_LIST_LESSONS_SUCCESS";
export const FETCH_LIST_LESSONS_FAILURE = "FETCH_LIST_LESSONS_FAILURE";
export const FETCH_PORTFOLIO = "FETCH_PORTFOLIO";
export const FETCH_PORTFOLIO_SUCCESS = "FETCH_PORTFOLIO_SUCCESS";
export const FETCH_PORTFOLIO_FAILURE = "FETCH_PORTFOLIO_FAILURE";
export const FETCH_DATA_DOWNLOAD_CSV = "FETCH_DATA_DOWNLOAD_CSV";
export const FETCH_DATA_DOWNLOAD_CSV_SUCCESS =
  "FETCH_DATA_DOWNLOAD_CSV_SUCCESS";
export const FETCH_DATA_DOWNLOAD_CSV_FAILURE =
  "FETCH_DATA_DOWNLOAD_CSV_FAILURE";
export const FETCH_DOWNLOAD_OPPA_CSV = "FETCH_DOWNLOAD_OPPA_CSV";
export const FETCH_DOWNLOAD_OPPA_CSV_SUCCESS =
  "FETCH_DOWNLOAD_OPPA_CSV_SUCCESS";
export const FETCH_DOWNLOAD_OPPA_CSV_FAILURE =
  "FETCH_DOWNLOAD_OPPA_CSV_FAILURE";
export const FETCH_DATA_ASSESSMENTS_CSV = "FETCH_DATA_ASSESSMENTS_CSV";
export const FETCH_DATA_ASSESSMENTS_CSV_SUCCESS =
  "FETCH_DATA_ASSESSMENTS_CSV_SUCCESS";
export const FETCH_DATA_ASSESSMENTS_CSV_FAILURE =
  "FETCH_DATA_ASSESSMENTS_CSV_FAILURE";
export const FETCH_ASSESSMENT = "FETCH_ASSESSMENT";
export const FETCH_ASSESSMENT_SUCCESS = "FETCH_ASSESSMENT_SUCCESS";
export const FETCH_ASSESSMENT_FAILURE = "FETCH_ASSESSMENT_FAILURE";
export const FETCH_ASSESSMENT_PAST = "FETCH_ASSESSMENT_PAST";
export const FETCH_ASSESSMENT_PAST_SUCCESS = "FETCH_ASSESSMENT_PAST_SUCCESS";
export const FETCH_ASSESSMENT_PAST_FAILURE = "FETCH_ASSESSMENT_PAST_FAILURE";
export const FETCH_AVERAGE_ASSESSMENT = "FETCH_AVERAGE_ASSESSMENT";
export const FETCH_AVERAGE_ASSESSMENT_SUCCESS =
  "FETCH_AVERAGE_ASSESSMENT_SUCCESS";
export const FETCH_AVERAGE_ASSESSMENT_FAILURE =
  "FETCH_AVERAGE_ASSESSMENT_FAILURE";
export const FETCH_TEMPORARY_TOKEN = "FETCH_TEMPORARY_TOKEN";
export const FETCH_TEMPORARY_TOKEN_SUCCESS = "FETCH_TEMPORARY_TOKEN_SUCCESS";
export const FETCH_TEMPORARY_TOKEN_FAILURE = "FETCH_TEMPORARY_TOKEN_FAILURE";
export const FETCH_AVERAGE_ASSESSMENT_BY_GRADE =
  "FETCH_AVERAGE_ASSESSMENT_BY_GRADE";
export const FETCH_AVERAGE_ASSESSMENT_BY_GRADE_SUCCESS =
  "FETCH_AVERAGE_ASSESSMENT_BY_GRADE_SUCCESS";
export const FETCH_AVERAGE_ASSESSMENT_BY_GRADE_FAILURE =
  "FETCH_AVERAGE_ASSESSMENT_BY_GRADE_FAILURE";
export const FETCH_ALL_DISTRIBUTIONS_ASSESSMENT =
  "FETCH_ALL_DISTRIBUTIONS_ASSESSMENT";
export const FETCH_ALL_DISTRIBUTIONS_ASSESSMENT_SUCCESS =
  "FETCH_ALL_DISTRIBUTIONS_ASSESSMENT_SUCCESS";
export const FETCH_ALL_DISTRIBUTIONS_ASSESSMENT_FAILURE =
  "FETCH_ALL_DISTRIBUTIONS_ASSESSMENT_FAILURE";
export const FETCH_COMPLETION_STATUSES = "FETCH_COMPLETION_STATUSES";
export const FETCH_COMPLETION_STATUSES_SUCCESS =
  "FETCH_COMPLETION_STATUSES_SUCCESS";
export const UPDATE_ASSESSMENT_LAST_ACTIVE = "UPDATE_ASSESSMENT_LAST_ACTIVE";
export const UPDATE_ASSESSMENT_LAST_ACTIVE_SUCCESS =
  "UPDATE_ASSESSMENT_LAST_ACTIVE_SUCCESS";
export const UPDATE_ASSESSMENT_REPORT = "UPDATE_ASSESSMENT_REPORT";
export const UPDATE_ASSESSMENT_REPORT_SUCCESS =
  "UPDATE_ASSESSMENT_REPORT_SUCCESS";
export const RESET_STUDENT_PASSWORD = "RESET_STUDENT_PASSWORD";
export const RESET_STUDENT_PASSWORD_SUCCESS = "RESET_STUDENT_PASSWORD_SUCCESS";
export const CLEAR_STUDENTS = "CLEAR_STUDENTS";
export const POST_LESSON_COMPLETED = "POST_LESSON_COMPLETED";
export const POST_LESSON_COMPLETED_SUCCESS = "POST_LESSON_COMPLETED_SUCCESS";
export const POST_LESSON_COMPLETED_SUCCESS_MESSAGE = "Lessonを完了しました";
export const FETCH_LESSON_RETROSPECTIVES = "FETCH_LESSON_RETROSPECTIVES";
export const FETCH_LESSON_RETROSPECTIVES_SUCCESS =
  "FETCH_LESSON_RETROSPECTIVES_SUCCESS";
export const POST_LESSON_RETROSPECTIVES = "POST_LESSON_RETROSPECTIVES";
export const POST_LESSON_RETROSPECTIVES_SUCCESS =
  "POST_LESSON_RETROSPECTIVES_SUCCESS";
export const FETCH_ONE_PAGE_PORTFOLIO_ASSESSMENT =
  "FETCH_ONE_PAGE_PORTFOLIO_ASSESSMENT";
export const FETCH_ONE_PAGE_PORTFOLIO_ASSESSMENT_SUCCESS =
  "FETCH_ONE_PAGE_PORTFOLIO_ASSESSMENT_SUCCESS";

export const FETCH_ONE_PAGE_PORTFOLIO_ASSESSMENTS =
  "FETCH_ONE_PAGE_PORTFOLIO_ASSESSMENTS";
export const FETCH_ONE_PAGE_PORTFOLIO_ASSESSMENTS_SUCCESS =
  "FETCH_ONE_PAGE_PORTFOLIO_ASSESSMENTS_SUCCESS";

export const FETCH_TEACHING_HINT_INTRODUCTIONS =
  "FETCH_TEACHING_HINT_INTRODUCTIONS";
export const FETCH_TEACHING_HINT_INTRODUCTIONS_SUCCESS =
  "FETCH_TEACHING_HINT_INTRODUCTIONS_SUCCESS";
export const FETCH_NOTIFICATION_TEACHING_HINT_INTRODUCTIONS_LESSON_ID =
  "FETCH_NOTIFICATION_TEACHING_HINT_INTRODUCTIONS_LESSON_ID";
export const FETCH_NOTIFICATION_TEACHING_HINT_INTRODUCTIONS_LESSON_ID_SUCCESS =
  "FETCH_NOTIFICATION_TEACHING_HINT_INTRODUCTIONS_LESSON_ID_SUCCESS";
export const FETCH_TEACHING_HINT_GROUP_WORKS =
  "FETCH_TEACHING_HINT_GROUP_WORKS";
export const FETCH_TEACHING_HINT_GROUP_WORKS_SUCCESS =
  "FETCH_TEACHING_HINT_GROUP_WORKS_SUCCESS";
export const FETCH_TEACHER_SURVEY = "FETCH_TEACHER_SURVEY";
export const FETCH_TEACHER_SURVEY_SUCCESS = "FETCH_TEACHER_SURVEY_SUCCESS";
export const UPDATE_TEACHER_SURVEY_SHOWN = "UPDATE_TEACHER_SURVEY_SHOWN";
export const UPDATE_TEACHER_SURVEY_SHOWN_SUCCESS =
  "UPDATE_TEACHER_SURVEY_SHOWN_SUCCESS";
export const UPDATE_TEACHER_SURVEY = "UPDATE_TEACHER_SURVEY";
export const UPDATE_TEACHER_SURVEY_SUCCESS = "UPDATE_TEACHER_SURVEY_SUCCESS";

export const CREATE_TEACHER_SURVEY = "CREATE_TEACHER_SURVEY";
export const CREATE_TEACHER_SURVEY_SUCCESS = "CREATE_TEACHER_SURVEY_SUCCESS";

export const CREATE_GROUP_SUCCESS_MESSAGE = "グループを作成しました";
export const CREATE_GROUP_FAILURE_MESSAGE = "このグループは既に存在します";
export const BULK_CREATE_GROUPS_SUCCESS_MESSAGE = "グループを作成しました";
export const UPDATE_GROUP_SUCCESS_MESSAGE = "グループを更新しました";
export const UPDATE_GROUP_FAILURE_MESSAGE = "このグループは既に存在します";
export const UPDATE_TEACHER_PASSWORD_SUCCESS_MESSAGE =
  "パスワードの更新に成功しました";
export const RESET_TEACHER_PASSWORD_SUCCESS_MESSAGE =
  "パスワードリセットメールを送信しました。";
export const RESET_TEACHER_PASSWORD_FAILURE_MESSAGE =
  "送信プロセス中にエラーが発生しました。";
export const DELETE_COMMENT_SUCCESS_MSG = "コメントを削除しました";
export const CREATE_COMMENT_SUCCESS_MSG = "コメントを送信しました";
export const UPDATE_COMMENT_SUCCESS_MSG = "コメントを更新しました";
export const CREATE_EVALUATION_SUCCESS_MSG = "評価を保存しました";
export const TOGGLE_COMMENT_SUCCESS_MSG = "コメントを更新しました";
export const SEND_FEEDBACK_COMMENT_SUCCESS_MSG = "保存しました";
export const TOGGLE_ANSWER_ERROR_MSG =
  "学生向けの教材を公開していないため、この機能を使用できません";
export const PUBLISH_LESSON_SUCCESS_MSG = "Lessonを公開しました";
export const UNPUBLISH_LESSON_SUCCESS_MSG = "Lessonを非公開にしました";
export const PUBLISH_TEACHING_MATERIAL_SUCCESS_MSG = "教材を公開しました";
export const UNPUBLISH_TEACHING_MATERIAL_SUCCESS_MSG = "教材を非公開にしました";

export const LOGOUT_SUCCESS_MESSAGE = "ログアウトしました。";
export const CHECK_UUID = "CHECK_UUID";
export const CHECK_UUID_SUCCESS = "CHECK_UUID_SUCCESS";
export const CHECK_UUID_FAILURE = "CHECK_UUID_FAILURE";
export const CHECK_UUID_FAILURE_MSG =
  "有効期限が切れています。再度パスワードのリセットの対応をお願いします";
export const RESET_STUDENT_PASSWORD_SUCCESS_MESSAGE =
  "パスワードの初期化に成功しました";

export const ACTION_503 = "ACTION_503";
export const ACTION_503_MESSAGE = "サービスが利用できません";

export const API_URL = `${
  process.env.REACT_APP_API_URL ??
  window.location.protocol + "//" + window.location.host
}/api/v1/teacher`;

export const getUuidStatus = (uuid: string) => ({
  types: CHECK_UUID as typeof CHECK_UUID,
  payload: {
    request: {
      data: { uuid },
      method: "get",
      url: `${API_URL}/teachers/check_reset_password_token`,
    },
  },
});

export const login = (email: string, password: string, remember: boolean) => ({
  types: LOGIN as typeof LOGIN,
  payload: {
    request: {
      data: { email, password, remember },
      method: "post",
      url: `${API_URL}/login`,
    },
  },
});

export const verifyMFA = (ott: string, mfa_code: string) => ({
  types: VERIFY_MFA as typeof VERIFY_MFA,
  payload: {
    request: {
      data: { ott, mfa_code },
      method: "post",
      url: `${API_URL}/teachers/verify_mfa`,
    },
  },
});

export const logout = () => ({
  types: LOGOUT as typeof LOGOUT,
  payload: {
    request: {
      data: {},
      method: "delete",
      url: `${API_URL}/logout`,
    },
  },
});

export const fetchInitialData = () => ({
  types: FETCH_INITIAL_DATA as typeof FETCH_INITIAL_DATA,
  payload: {
    request: {
      data: {},
      method: "get",
      url: `${API_URL}/teachers/initial_data`,
    },
  },
});

export const updateTeacherPassword = (uuid: string, password: string) => ({
  types: UPDATE_TEACHER_PASSWORD as typeof UPDATE_TEACHER_PASSWORD,
  payload: {
    request: {
      data: { uuid, password },
      method: "post",
      url: `${API_URL}/teachers/update_password`,
    },
  },
});

export const updateTeacherSurveyShown = () => ({
  types: UPDATE_TEACHER_SURVEY_SHOWN as typeof UPDATE_TEACHER_SURVEY_SHOWN,
  payload: {
    request: {
      method: "PUT",
      url: `${API_URL}/teachers/update_teacher_survey_shown`,
    },
  },
});

export const resetTeacherPassword = (email: string) => ({
  types: RESET_TEACHER_PASSWORD as typeof RESET_TEACHER_PASSWORD,
  payload: {
    request: {
      data: { email, type: "dlp" },
      method: "post",
      url: `${API_URL}/teachers/reset_password`,
    },
  },
});

export const fetchTeachingMaterial = (id: number) => {
  return {
    types: FETCH_TEACHING_MATERIAL as typeof FETCH_TEACHING_MATERIAL,
    payload: {
      request: {
        method: "get",
        url: `${API_URL}/teaching_materials/${id}`,
      },
    },
  };
};

export const fetchCountAnswers = (school_id: number) => ({
  types: FETCH_COUNT_ANSWERS as typeof FETCH_COUNT_ANSWERS,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/schools/${school_id}/count_answers`,
    },
  },
});

export const fetchActiveLearningStoryBoard = (id: number) => ({
  types: FETCH_ACTIVE_LEARNING_STORY_BOARD as typeof FETCH_ACTIVE_LEARNING_STORY_BOARD,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/active_learning_themes/${id}/story_board`,
    },
  },
});

export const fetchTeachingMaterials = (class_ids?: number[]) => {
  const data: any = {};
  if (class_ids) data.class_ids = class_ids;

  return {
    types: FETCH_TEACHING_MATERIALS as typeof FETCH_TEACHING_MATERIALS,
    payload: {
      request: {
        data,
        method: "get",
        url: `${API_URL}/teaching_materials`,
      },
    },
  };
};

export const fetchActiveLearningMaterials = (class_ids?: number[]) => {
  const data: any = {};
  if (class_ids) data.class_ids = class_ids;

  return {
    types: FETCH_ACTIVE_LEARNING_MATERIALS as typeof FETCH_ACTIVE_LEARNING_MATERIALS,
    payload: {
      request: {
        data,
        method: "get",
        url: `${API_URL}/active_learning_materials`,
      },
    },
  };
};

export const fetchTeachingHintsIntroductions = (
  lesson_id: number,
  hint_type?: string,
) => {
  const data: any = {};
  if (hint_type) data.hint_type = hint_type;
  return {
    types: FETCH_TEACHING_HINT_INTRODUCTIONS as typeof FETCH_TEACHING_HINT_INTRODUCTIONS,
    payload: {
      request: {
        data,
        method: "get",
        url: `${API_URL}/lessons/${lesson_id}/teaching_hints_introductions`,
      },
    },
  };
};

export const fetchNotificationTeachingHintsIntroductionLessonId = (
  class_ids: number[],
) => {
  return {
    types: FETCH_NOTIFICATION_TEACHING_HINT_INTRODUCTIONS_LESSON_ID as typeof FETCH_NOTIFICATION_TEACHING_HINT_INTRODUCTIONS_LESSON_ID,
    payload: {
      request: {
        data: { class_ids: class_ids.join(",") },
        method: "get",
        url: `${API_URL}/teaching_hints_introductions/notify`,
      },
    },
  };
};

export const fetchTeachingHintsGroupWorks = (lesson_id: number) => {
  return {
    types: FETCH_TEACHING_HINT_GROUP_WORKS as typeof FETCH_TEACHING_HINT_GROUP_WORKS,
    payload: {
      request: {
        method: "get",
        url: `${API_URL}/lessons/${lesson_id}/teaching_hints_group_works`,
      },
    },
  };
};

export const fetchTeacherSurveyData = () => {
  return {
    types: FETCH_TEACHER_SURVEY as typeof FETCH_TEACHER_SURVEY,
    payload: {
      request: {
        method: "get",
        url: `${API_URL}/teacher_survey`,
      },
    },
  };
};

export const fetchActiveLearningMaterialLessons = (
  material_code: string,
  id: string,
) => ({
  types: FETCH_ACTIVE_LEARNING_MATERIAL_LESSONS as typeof FETCH_ACTIVE_LEARNING_MATERIAL_LESSONS,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/active_learning_materials/${material_code}/active_learning_material_lessons/${id}`,
    },
  },
});

export const fetchActiveLearningMaterialLessonsData = () => ({
  types: FETCH_ACTIVE_LEARNING_MATERIAL_LESSONS_DATA as typeof FETCH_ACTIVE_LEARNING_MATERIAL_LESSONS_DATA,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/active_learning_material_lessons`,
    },
  },
});

export const fetchActiveLearningAnswers = (class_ids: string) => {
  return {
    types: FETCH_ACTIVE_LEARNING_ANSWERS as typeof FETCH_ACTIVE_LEARNING_ANSWERS,
    payload: {
      request: {
        data: { class_ids },
        method: "get",
        url: `${API_URL}/active_learning_answers`,
      },
    },
  };
};

export const fetchActiveLearningStudentAnswers = (student_id: number) => {
  return {
    types: FETCH_ACTIVE_LEARNING_STUDENT_ANSWERS as typeof FETCH_ACTIVE_LEARNING_STUDENT_ANSWERS,
    payload: {
      request: {
        method: "get",
        url: `${API_URL}/active_learning_answers/student_answer?student_id=${student_id}`,
      },
    },
  };
};

export const clearTeachingMaterials = () => ({
  types: CLEAR_TEACHING_MATERIALS as typeof CLEAR_TEACHING_MATERIALS,
});

export const fetchSimpleTeachingMaterials = (class_id: number) => ({
  types: FETCH_SIMPLE_TEACHING_MATERIALS as typeof FETCH_SIMPLE_TEACHING_MATERIALS,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/classes/${class_id}/list_teaching_materials`,
    },
  },
});

export const createTeachingMaterialViewLog = (
  teaching_material_id: number,
  lesson_id: number,
  page_no: number,
  klass_ids: string,
) => ({
  types: CREATE_TEACHING_MATERIAL_VIEW_LOG as typeof CREATE_TEACHING_MATERIAL_VIEW_LOG,
  payload: {
    request: {
      method: "post",
      data: {
        teaching_material_id,
        lesson_id,
        page_no,
        klass_ids,
      },
      url: `${API_URL}/teaching_materials/${teaching_material_id}/view_logs`,
    },
  },
});

export const createVideoChapterViewLog = (
  lesson_id: number,
  chapter_id: number,
  klass_ids: string,
) => ({
  types: CREATE_VIDEO_CHAPTER_VIEW_LOG as typeof CREATE_VIDEO_CHAPTER_VIEW_LOG,
  payload: {
    request: {
      method: "post",
      data: {
        lesson_id,
        klass_ids,
      },
      url: `${API_URL}/video_chapters/${chapter_id}/view_logs`,
    },
  },
});

export const fetchStudents = (class_ids: number[]) => ({
  types: FETCH_STUDENTS as typeof FETCH_STUDENTS,
  payload: {
    request: {
      data: { class_ids: class_ids.join(","), load_answered_status: true },
      method: "get",
      url: `${API_URL}/students`,
    },
  },
});

export const fetchAssessmentStudents = (class_id: number) => ({
  types: FETCH_ASSESSMENT_STUDENTS as typeof FETCH_ASSESSMENT_STUDENTS,
  payload: {
    request: {
      data: { class_id },
      method: "get",
      url: `${API_URL}/assessments/students`,
    },
  },
});

export const fetchGroups = (class_ids: number[]) => ({
  types: FETCH_GROUPS as typeof FETCH_GROUPS,
  payload: {
    request: {
      data: { class_ids: class_ids.join(",") },
      method: "get",
      url: `${API_URL}/groups`,
    },
  },
});

export const fetchListLessons = (
  student_id: number,
  class_id: number,
  teaching_material_id: number,
) => ({
  types: FETCH_LIST_LESSONS as typeof FETCH_LIST_LESSONS,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/teaching_materials/${teaching_material_id}/lessons?class_id=${class_id}&student_id=${student_id}`,
    },
  },
});

export const fetchPortfolio = (
  student_id: number,
  class_id: number,
  teaching_material_id: number,
) => ({
  types: FETCH_PORTFOLIO as typeof FETCH_PORTFOLIO,
  payload: {
    request: {
      data: { student_id, class_id },
      method: "get",
      url: `${API_URL}/teaching_materials/${teaching_material_id}/portfolio`,
    },
  },
});

export const fetchClasses = () => ({
  types: FETCH_CLASSES as typeof FETCH_CLASSES,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/classes/`,
    },
  },
});

export const fetchClassesByGrade = () => ({
  types: FETCH_CLASSES_BY_GRADE as typeof FETCH_CLASSES_BY_GRADE,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/classes/classes_by_grade`,
    },
  },
});

export const fetchActiveLearningMaterialAnswers = (mitsuwa_id: string) => ({
  types: FETCH_ACTIVE_LEARNING_MATERIAL_ANSWERS as typeof FETCH_ACTIVE_LEARNING_MATERIAL_ANSWERS,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/active_learning_materials/${mitsuwa_id}/active_learning_answers/answers`,
    },
  },
});

export const fetchKlassIdsWithActiveLearningMaterials = () => ({
  types: FETCH_KLASS_IDS_WITH_ACTIVE_LEARNING_MATERIALS as typeof FETCH_KLASS_IDS_WITH_ACTIVE_LEARNING_MATERIALS,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/classes/klass_ids_with_active_learning_materials`,
    },
  },
});

export const fetchSchoolGoals = () => ({
  types: FETCH_SCHOOL_GOALS as typeof FETCH_SCHOOL_GOALS,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/schools`,
    },
  },
});

export const fetchLessons = () => ({
  types: FETCH_LESSONS as typeof FETCH_LESSONS,
  payload: {
    request: {
      data: {},
      method: "get",
      url: `${API_URL}/lessons`,
    },
  },
});

export const fetchLesson = (id: number) => ({
  types: FETCH_LESSON as typeof FETCH_LESSON,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/lessons/${id}`,
    },
  },
});

export const fetchLessonVideoChapters = (
  class_ids: number[],
  lesson_id: number,
) => ({
  types: FETCH_LESSON_VIDEO_CHAPTERS as typeof FETCH_LESSON_VIDEO_CHAPTERS,
  payload: {
    request: {
      method: "get",
      data: { class_ids: class_ids.join(",") },
      url: `${API_URL}/lessons/${lesson_id}/video_chapters`,
    },
  },
});

export const fetchActiveLearningLesson = (
  id: number,
  active_learning_code: string,
  projection?: boolean,
) => ({
  types: FETCH_LESSON_ACTIVE_LEARNING as typeof FETCH_LESSON_ACTIVE_LEARNING,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/active_learning_lessons/${id}?active_learning_code=${active_learning_code}&projection=${
        projection ?? false
      }`,
    },
  },
});

export const fetchActiveLearningThemes = () => ({
  types: FETCH_ACTIVE_LEARNING_THEMES as typeof FETCH_ACTIVE_LEARNING_THEMES,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/active_learning_themes`,
    },
  },
});

export const fetchDataDownloadCSV = (
  lesson_id: number,
  class_id: number,
  teaching_material_id: number,
) => ({
  types: FETCH_DATA_DOWNLOAD_CSV as typeof FETCH_DATA_DOWNLOAD_CSV,
  payload: {
    request: {
      data: {},
      method: "get",
      url: `${API_URL}/lessons/${lesson_id}/download_csv?class_id=${class_id}&teaching_material_id=${teaching_material_id}`,
    },
  },
});

export const fetchDownloadOppaCSV = (
  teaching_material_id: number,
  class_id: number,
) => ({
  types: FETCH_DOWNLOAD_OPPA_CSV as typeof FETCH_DOWNLOAD_OPPA_CSV,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/teaching_materials/${teaching_material_id}/download_oppa_csv?class_id=${class_id}`,
    },
  },
});

export const fetchDataAssessmentCSV = (class_id: number) => ({
  types: FETCH_DATA_ASSESSMENTS_CSV as typeof FETCH_DATA_ASSESSMENTS_CSV,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/assessments/download_csv?class_id=${class_id}`,
    },
  },
});

export const createGroup = (class_id: number, name: string) => {
  return {
    types: CREATE_GROUP as typeof CREATE_GROUP,
    payload: {
      request: {
        data: {
          name,
          class_id,
        },
        method: "post",
        url: `${API_URL}/groups`,
      },
    },
  };
};

export const bulkCreateGroups = (class_id: number, num: number) => {
  return {
    types: BULK_CREATE_GROUPS as typeof BULK_CREATE_GROUPS,
    payload: {
      request: {
        data: {
          class_id,
          num,
        },
        method: "post",
        url: `${API_URL}/groups/bulk_create`,
      },
    },
  };
};

export const updateGroup = (group: IGroup) => {
  return {
    types: UPDATE_GROUP as typeof UPDATE_GROUP,
    payload: {
      request: {
        data: {
          id: group.id,
          name: group.name,
        },
        method: "put",
        url: `${API_URL}/groups/${group.id}`,
      },
    },
  };
};

export const createComment = (answer_id: number, content: string) => {
  return {
    types: CREATE_COMMENT as typeof CREATE_COMMENT,
    payload: {
      request: {
        data: { content },
        method: "post",
        url: `${API_URL}/answers/${answer_id}/answer_comments`,
      },
    },
  };
};

export const updateTeacherSurvey = (teacherSurvey: ISubmitTeacherSurvey) => {
  return {
    types: UPDATE_TEACHER_SURVEY as typeof UPDATE_TEACHER_SURVEY,
    payload: {
      request: {
        data: { teacher_survey: { ...teacherSurvey } },
        method: "PUT",
        url: `${API_URL}/teacher_survey`,
      },
    },
  };
};

export const createTeacherSurvey = (teacherSurvey: ISubmitTeacherSurvey) => {
  return {
    types: CREATE_TEACHER_SURVEY as typeof CREATE_TEACHER_SURVEY,
    payload: {
      request: {
        data: { teacher_survey: { ...teacherSurvey } },
        method: "POST",
        url: `${API_URL}/teacher_survey`,
      },
    },
  };
};

export const updateComment = (
  answer_id: number,
  content: string,
  comment_id: number,
) => {
  return {
    types: UPDATE_COMMENT as typeof UPDATE_COMMENT,
    payload: {
      request: {
        data: { content },
        method: "PUT",
        url: `${API_URL}/answers/${answer_id}/answer_comments/${comment_id}`,
      },
    },
  };
};

export const deleteComment = (answer_id: number, comment_id: number) => {
  return {
    types: DELETE_COMMENT as typeof DELETE_COMMENT,
    payload: {
      request: {
        data: {},
        method: "delete",
        url: `${API_URL}/answers/${answer_id}/answer_comments/${comment_id}`,
      },
    },
  };
};

export const fetchAnswers = (issue_id: number, class_ids: number[]) => {
  return {
    types: FETCH_ANSWERS as typeof FETCH_ANSWERS,
    payload: {
      request: {
        data: { class_ids: class_ids.join(",") },
        method: "get",
        url: `${API_URL}/issues/${issue_id}/answers`,
      },
    },
  };
};

export const fetchAnswersFromOtherSchools = (
  issue_id: number,
  class_ids: number[],
) => {
  return {
    types: FETCH_ANSWERS_FROM_OTHER_SCHOOLS as typeof FETCH_ANSWERS_FROM_OTHER_SCHOOLS,
    payload: {
      request: {
        data: { class_ids: class_ids.join(",") },
        method: "get",
        url: `${API_URL}/issues/${issue_id}/public_answers`,
      },
    },
  };
};

export const sendFeedbackComment = (
  student_id: number,
  feedback_comment: string,
) => {
  return {
    types: SEND_FEEDBACK_COMMENT as typeof SEND_FEEDBACK_COMMENT,
    payload: {
      request: {
        data: { student_id, feedback_comment },
        method: "POST",
        url: `${API_URL}/assessments/feedback_comment`,
      },
    },
  };
};

export const fetchAnswerSummaries = (student_id: number) => {
  return {
    types: FETCH_ANSWER_SUMMARIES as typeof FETCH_ANSWER_SUMMARIES,
    payload: {
      request: {
        method: "get",
        url: `${API_URL}/students/${student_id}/answers`,
      },
    },
  };
};

export const publishTeachingMaterial = (
  class_id: number,
  teaching_material_id: number,
) => {
  return {
    types: PUBLISH_TEACHING_MATERIAL as typeof PUBLISH_TEACHING_MATERIAL,
    payload: {
      request: {
        data: { class_id },
        method: "post",
        url: `${API_URL}/teaching_materials/${teaching_material_id}/publish`,
      },
    },
  };
};

export const unpublishTeachingMaterial = (
  class_id: number,
  teaching_material_id: number,
) => {
  return {
    types: UNPUBLISH_TEACHING_MATERIAL as typeof UNPUBLISH_TEACHING_MATERIAL,
    payload: {
      request: {
        data: { class_id },
        method: "post",
        url: `${API_URL}/teaching_materials/${teaching_material_id}/unpublish`,
      },
    },
  };
};

export const publishLesson = (class_ids: number[], lesson_id: number) => {
  return {
    types: PUBLISH_LESSON as typeof PUBLISH_LESSON,
    payload: {
      request: {
        data: { class_ids },
        method: "POST",
        url: `${API_URL}/lessons/${lesson_id}/publish`,
      },
    },
  };
};

export const unpublishLesson = (class_ids: number[], lesson_id: number) => {
  return {
    types: UNPUBLISH_LESSON as typeof UNPUBLISH_LESSON,
    payload: {
      request: {
        data: { class_ids },
        method: "POST",
        url: `${API_URL}/lessons/${lesson_id}/unpublish`,
      },
    },
  };
};

export const toggleComment = (
  answer_id: number,
  comment_id: number,
  is_hidden: boolean,
) => {
  return {
    types: TOGGLE_COMMENT as typeof TOGGLE_COMMENT,
    payload: {
      request: {
        data: { is_hidden },
        method: "PUT",
        url: `${API_URL}/answers/${answer_id}/answer_comments/${comment_id}/hidden`,
      },
    },
  };
};

export const nameOpened = (issue_id: number, class_id: number) => {
  return {
    types: NAME_OPENED as typeof NAME_OPENED,
    payload: {
      request: {
        data: { class_id },
        method: "post",
        url: `${API_URL}/issues/${issue_id}/name_opened`,
      },
    },
  };
};

export const nameClosed = (issue_id: number, class_id: number) => {
  return {
    types: NAME_CLOSED as typeof NAME_CLOSED,
    payload: {
      request: {
        data: { class_id },
        method: "post",
        url: `${API_URL}/issues/${issue_id}/name_closed`,
      },
    },
  };
};

export const answerOpened = (issue_id: number, class_id: number) => {
  return {
    types: ANSWER_OPENED as typeof ANSWER_OPENED,
    payload: {
      request: {
        data: { class_id },
        method: "post",
        url: `${API_URL}/issues/${issue_id}/answer_opened`,
      },
    },
  };
};

export const answerClosed = (issue_id: number, class_id: number) => {
  return {
    types: ANSWER_CLOSED as typeof ANSWER_CLOSED,
    payload: {
      request: {
        data: { class_id },
        method: "post",
        url: `${API_URL}/issues/${issue_id}/answer_closed`,
      },
    },
  };
};

export const fetchPackages = (class_id: number) => {
  return {
    types: FETCH_PACKAGES as typeof FETCH_PACKAGES,
    payload: {
      request: {
        method: "get",
        url: `${API_URL}/packages?class_id=${class_id}`,
      },
    },
  };
};

export const fetchSurveyAnswers = (
  teaching_material_id: number,
  student_id: number,
) => {
  return {
    types: FETCH_SURVEY_ANSWERS as typeof FETCH_SURVEY_ANSWERS,
    payload: {
      request: {
        method: "get",
        url: `${API_URL}/survey_answers/${teaching_material_id}/student_answer?student_id=${student_id}`,
      },
    },
  };
};

export const fetchDetailsSurvey = (student_id: number, package_id: number) => {
  return {
    types: FETCH_DETAILS_SURVEY as typeof FETCH_DETAILS_SURVEY,
    payload: {
      request: {
        method: "get",
        url: `${API_URL}/survey_answers?student_id=${student_id}&package_id=${package_id}`,
      },
    },
  };
};

export const fetchAssessment = (student_id: number, class_id: number) => ({
  types: FETCH_ASSESSMENT as typeof FETCH_ASSESSMENT,
  payload: {
    request: {
      data: { student_id, class_id },
      method: "get",
      url: `${API_URL}/assessments`,
    },
  },
});

export const fetchAssessmentPast = (student_id: number, class_id: number) => ({
  types: FETCH_ASSESSMENT_PAST as typeof FETCH_ASSESSMENT_PAST,
  payload: {
    request: {
      data: { student_id, class_id },
      method: "get",
      url: `${API_URL}/assessments/in_past`,
    },
  },
});

export const fetchAvgAssessment = (class_id: number) => ({
  types: FETCH_AVERAGE_ASSESSMENT as typeof FETCH_AVERAGE_ASSESSMENT,
  payload: {
    request: {
      data: { class_id },
      method: "get",
      url: `${API_URL}/assessments/summary_by_class`,
    },
  },
});

export const fetchAvgAssessmentByGrade = (grade: number) => ({
  types: FETCH_AVERAGE_ASSESSMENT_BY_GRADE as typeof FETCH_AVERAGE_ASSESSMENT_BY_GRADE,
  payload: {
    request: {
      data: { grade },
      method: "get",
      url: `${API_URL}/assessments/summary_by_grade`,
    },
  },
});

export const fetchTemporaryToken = () => ({
  types: FETCH_TEMPORARY_TOKEN as typeof FETCH_TEMPORARY_TOKEN,
  payload: {
    request: {
      method: "post",
      url: `${API_URL}/sessions/temporary`,
      data: {},
    },
  },
});

export const fetchAllDistributionsAssessment = (class_id: number) => ({
  types: FETCH_ALL_DISTRIBUTIONS_ASSESSMENT as typeof FETCH_ALL_DISTRIBUTIONS_ASSESSMENT,
  payload: {
    request: {
      data: { class_id },
      method: "get",
      url: `${API_URL}/assessments/all_distributions`,
    },
  },
});

export const fetchOnePagePortfolioAssessment = (
  one_page_portfolio_assessment_id: number,
) => {
  return {
    types: FETCH_ONE_PAGE_PORTFOLIO_ASSESSMENT as typeof FETCH_ONE_PAGE_PORTFOLIO_ASSESSMENT,
    payload: {
      request: {
        method: "get",
        url: `${API_URL}/one_page_portfolio_assessments/${one_page_portfolio_assessment_id}`,
      },
    },
  };
};

export const fetchOnePagePortfolioAssessments = () => {
  return {
    types: FETCH_ONE_PAGE_PORTFOLIO_ASSESSMENTS as typeof FETCH_ONE_PAGE_PORTFOLIO_ASSESSMENTS,
    payload: {
      request: {
        method: "get",
        url: `${API_URL}/one_page_portfolio_assessments`,
      },
    },
  };
};

export const clearSuccessMessage = () => ({
  types: CLEAR_SUCCESS_MESSAGE as typeof CLEAR_SUCCESS_MESSAGE,
  payload: {},
});

export const clearErrorMessage = () => ({
  types: CLEAR_ERROR_MESSAGE as typeof CLEAR_ERROR_MESSAGE,
  payload: {},
});

export const clearTemporaryToken = () => ({
  types: CLEAR_TEMPORARY_TOKEN as typeof CLEAR_TEMPORARY_TOKEN,
  payload: {},
});

export const clearOTT = () => ({
  types: CLEAR_OTT as typeof CLEAR_OTT,
  payload: {},
});

export const deleteGroup = (group_id: number) => {
  return {
    types: DELETE_GROUP as typeof DELETE_GROUP,
    payload: {
      request: {
        data: {},
        method: "delete",
        url: `${API_URL}/groups/${group_id}`,
      },
    },
  };
};

export const updateAssessmentLastActive = () => ({
  types: UPDATE_ASSESSMENT_LAST_ACTIVE as typeof UPDATE_ASSESSMENT_LAST_ACTIVE,
  payload: {
    request: {
      data: {},
      method: "put",
      url: `${API_URL}/teachers/update_assessment_last_active_date`,
    },
  },
});

export const updateAssessmentReport = (class_id: number) => ({
  types: UPDATE_ASSESSMENT_REPORT as typeof UPDATE_ASSESSMENT_REPORT,
  payload: {
    request: {
      data: { class_id },
      method: "put",
      url: `${API_URL}/assessments/update_report`,
    },
  },
});

export const resetStudentPassword = (id: number) => ({
  types: RESET_STUDENT_PASSWORD as typeof RESET_STUDENT_PASSWORD,
  payload: {
    request: {
      data: {},
      method: "post",
      url: `${API_URL}/students/${id}/reset_password`,
    },
  },
});

export const clearStudents = () => ({
  types: CLEAR_STUDENTS as typeof CLEAR_STUDENTS,
  payload: {},
});

export const fetchCompletionStatuses = (
  class_ids: number[],
  lesson_id: number,
) => ({
  types: FETCH_COMPLETION_STATUSES as typeof FETCH_COMPLETION_STATUSES,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/lessons/${lesson_id}/completion_statuses?class_ids=${class_ids}`,
    },
  },
});

export const postCompletedLesson = (
  class_ids: number[],
  lesson_id: number,
) => ({
  types: POST_LESSON_COMPLETED as typeof POST_LESSON_COMPLETED,
  payload: {
    request: {
      data: {
        class_ids,
        lesson_id,
      },
      method: "POST",
      url: `${API_URL}/lessons/${lesson_id}/complete`,
    },
  },
});

export const fetchLessonRetrospectives = (
  class_ids: string,
  lesson_id: number,
) => ({
  types: FETCH_LESSON_RETROSPECTIVES as typeof FETCH_LESSON_RETROSPECTIVES,
  payload: {
    request: {
      method: "GET",
      url: `${API_URL}/lessons/${lesson_id}/teacher_lesson_retrospectives?class_ids=${class_ids}`,
    },
  },
});

export const postLessonRetrospectives = (
  teacher_id: number,
  class_ids: string,
  lesson_id: number,
  score: number,
  lesson_delivery_score: number,
  group_work_score: number | null,
) => ({
  types: POST_LESSON_RETROSPECTIVES as typeof POST_LESSON_RETROSPECTIVES,
  payload: {
    request: {
      data: {
        teacher_id,
        class_ids,
        lesson_id,
        score,
        lesson_delivery_score,
        group_work_score,
      },
      method: "POST",
      url: `${API_URL}/lessons/${lesson_id}/teacher_lesson_retrospectives`,
    },
  },
});

type fetchLessonRetrospectivesSuccess = {
  types: typeof FETCH_LESSON_RETROSPECTIVES_SUCCESS;
  payload: {
    data: {
      teacher_lesson_retrospective: ITeacherLessonRetrospectives;
    };
  };
};

type postLessonRetrospectivesSuccess = {
  types: typeof POST_LESSON_RETROSPECTIVES_SUCCESS;
  payload: {
    data: ITeacherLessonRetrospectives;
  };
};

type postCompletedLessonSuccess = {
  types: typeof POST_LESSON_COMPLETED_SUCCESS;
  payload: {
    data: { message: string };
  };
};

type fetchCompletionStatusesSuccess = {
  types: typeof FETCH_COMPLETION_STATUSES_SUCCESS;
  payload: {
    data: ICompletionStatuses;
  };
};

type fetchAllDistributionsAssessmentSuccess = {
  types: typeof FETCH_ALL_DISTRIBUTIONS_ASSESSMENT_SUCCESS;
  payload: {
    data: {
      all_distributions: {
        first_term_no_distributions: IDistribution[] | null;
        last_term_no_distributions: IDistribution[] | null;
        previous_term_no_distributions: IDistribution[] | null;
      };
    };
  };
};

type fetchAssessmentPastSuccess = {
  types: typeof FETCH_ASSESSMENT_PAST_SUCCESS;
  payload: {
    data: {
      assessments: IAssessment[];
    };
  };
};

type fetchDataDownloadCSVSuccess = {
  types: typeof FETCH_DATA_DOWNLOAD_CSV_SUCCESS;
  payload: {
    data: {
      lesson: ILessonCSV;
    };
  };
};

type fetchDownloadOppaCSVSuccess = {
  types: typeof FETCH_DOWNLOAD_OPPA_CSV_SUCCESS;
  payload: {
    data: IOnePagePortfolioAssessmentCSVData;
  };
};

type fetchDataAssessmentsCSVSuccess = {
  types: typeof FETCH_DATA_ASSESSMENTS_CSV_SUCCESS;
  payload: {
    data: {
      assessments: IAssessmentCSV[];
    };
  };
};

type loginSuccess = {
  types: typeof LOGIN_SUCCESS;
  payload: {
    data: ILoginResponse | ILoginMFAResponse;
  };
};

type loginFailure = {
  types: typeof LOGIN_FAILURE;
  payload: {
    error: {
      message: string;
      field: string;
      status: number;
    };
  };
};

type verifyMFASuccess = {
  types: typeof VERIFY_MFA_SUCCESS;
  payload: {
    data: ILoginResponse;
  };
};

type verifyMFAFailure = {
  types: typeof VERIFY_MFA_FAILURE;
  payload: {
    error: {
      message: string;
      field: string;
      status: number;
    };
  };
};

type checkUuidSuccess = {
  types: typeof CHECK_UUID_SUCCESS;
  payload: {
    data: Record<string, unknown>;
  };
};

type checkUuidFailure = {
  types: typeof CHECK_UUID_FAILURE;
  payload: {
    error: {
      message: string;
      field: string;
      status: number;
    };
  };
};

type logoutSuccess = {
  types: typeof LOGOUT_SUCCESS;
  payload: {
    data: Record<string, unknown>;
  };
};

type fetchTeachingMaterialSuccess = {
  types: typeof FETCH_TEACHING_MATERIAL_SUCCESS;
  payload: {
    data: {
      data: {
        teaching_material: ITeachingMaterial;
      };
    };
  };
};

type fetchCountAnswersSuccess = {
  types: typeof FETCH_COUNT_ANSWERS_SUCCESS;
  payload: {
    data: {
      data: {
        school: ISchoolCountAnswers;
      };
    };
  };
};

type fetchInitialDataSuccess = {
  types: typeof FETCH_INITIAL_DATA_SUCCESS;
  payload: {
    data: {
      teacher: ITeacher;
      school_name: string;
      survey_enabled: boolean;
      teacher_survey_shown: boolean;
      teacher_survey_enabled: boolean;
      is_manager: boolean;
      only_assessment: boolean;
      assessment_last_active_date: string | null;
      available_item_codes: string[];
      is_any_unread_news: boolean;
      has_base: boolean;
      current_year: number;
      has_g4s_order: boolean;
      has_g4s_basic_order: boolean;
      has_dlp_order: boolean;
    };
  };
};

type updateTeacherPasswordSuccess = {
  types: typeof UPDATE_TEACHER_PASSWORD_SUCCESS;
  payload: {
    data: Record<string, never>;
  };
};

type updateTeacherSurveyShownSuccess = {
  types: typeof UPDATE_TEACHER_SURVEY_SHOWN_SUCCESS;
  payload: {
    data: Record<string, never>;
  };
};

type resetTeacherPasswordSuccess = {
  types: typeof RESET_TEACHER_PASSWORD_SUCCESS;
  payload: {
    data: Record<string, never>;
  };
};

type fetchTeachingMaterialsSuccess = {
  types: typeof FETCH_TEACHING_MATERIALS_SUCCESS;
  payload: {
    data: {
      data: {
        teaching_materials: ITeachingMaterial[];
      };
    };
  };
};

type fetchActiveLearningMaterialsSuccess = {
  types: typeof FETCH_ACTIVE_LEARNING_MATERIALS_SUCCESS;
  payload: {
    data: {
      data: {
        active_learning_materials: IActiveLearningMaterial[];
      };
    };
  };
};
type fetchTeachingHintsIntroductionsSuccess = {
  types: typeof FETCH_TEACHING_HINT_INTRODUCTIONS_SUCCESS;
  payload: {
    data: ITeachingHintsIntroductions;
  };
};

type fetchNotificationTeachingHintsIntroductionsLessonIdSuccess = {
  types: typeof FETCH_NOTIFICATION_TEACHING_HINT_INTRODUCTIONS_LESSON_ID_SUCCESS;
  payload: {
    data: {
      lesson_id: number;
    };
  };
};

type fetchTeachingHintsGroupWorksSuccess = {
  types: typeof FETCH_TEACHING_HINT_GROUP_WORKS_SUCCESS;
  payload: {
    data: ITeachingHintsGroupWorks;
  };
};
type fetchTeacherSurveySuccess = {
  types: typeof FETCH_TEACHER_SURVEY_SUCCESS;
  payload: {
    data: {
      teacher_survey: ITeacherSurvey | null;
      teacher_survey_shown: boolean;
    };
  };
};

type fetchActiveLearningMaterialAnswersSuccess = {
  types: typeof FETCH_ACTIVE_LEARNING_MATERIAL_ANSWERS_SUCCESS;
  payload: {
    data: {
      data: IActiveLearningMaterialAnswers[];
    };
  };
};

type fetchActiveLearningMaterialLessonsSuccess = {
  types: typeof FETCH_ACTIVE_LEARNING_MATERIAL_LESSONS_SUCCESS;
  payload: {
    data: {
      data: IActiveLearningMaterialLessons;
    };
  };
};

type fetchActiveLearningMaterialLessonsDataSuccess = {
  types: typeof FETCH_ACTIVE_LEARNING_MATERIAL_LESSONS_DATA_SUCCESS;
  payload: {
    data: {
      data: IActiveLearningMaterialLessonsData[];
    };
  };
};

type fetchActiveLearningAnswersSuccess = {
  types: typeof FETCH_ACTIVE_LEARNING_ANSWERS_SUCCESS;
  payload: {
    data: {
      students: IActiveLearningKlassStudentAnswers[];
    };
  };
};

type fetchActiveLearningStudentAnswersSuccess = {
  types: typeof FETCH_ACTIVE_LEARNING_STUDENT_ANSWERS_SUCCESS;
  payload: {
    data: {
      student: IActiveLearningStudentAnswers;
    };
  };
};

type fetchActiveLearningStoryBoardSuccess = {
  types: typeof FETCH_ACTIVE_LEARNING_STORY_BOARD_SUCCESS;
  payload: {
    data: {
      data: IActiveLearningStoryBoard;
    };
  };
};

type fetchSimpleTeachingMaterialsSuccess = {
  types: typeof FETCH_SIMPLE_TEACHING_MATERIALS_SUCCESS;
  payload: {
    data: {
      teaching_materials: ISimpleTeachingMaterial[];
    };
  };
};

type createTeachingMaterialViewLogSuccess = {
  types: typeof CREATE_TEACHING_MATERIAL_VIEW_LOG_SUCCESS;
  payload: {
    data: {
      id: number;
    };
  };
};

type createVideoChapterViewLogSuccess = {
  types: typeof CREATE_VIDEO_CHAPTER_VIEW_LOG_SUCCESS;
  payload: {
    data: {
      message: string;
    };
  };
};

type fetchListLessonsSuccess = {
  types: typeof FETCH_LIST_LESSONS_SUCCESS;
  payload: {
    data: {
      lessons: ILessonByTeachingMaterial[];
    };
  };
};

type fetchPortfolioSuccess = {
  types: typeof FETCH_PORTFOLIO_SUCCESS;
  payload: {
    data: {
      portfolio: IPortfolio;
    };
  };
};

type fetchPortfolioFailure = {
  types: typeof FETCH_PORTFOLIO_FAILURE;
  payload: {
    error: { message: string; field: string };
  };
};

type fetchLessonsSuccess = {
  types: typeof FETCH_LESSONS_SUCCESS;
  payload: {
    data: {
      lessons: ILesson[];
    };
  };
};

type fetchLessonSuccess = {
  types: typeof FETCH_LESSON_SUCCESS;
  payload: {
    data: {
      data: {
        lesson: ILesson;
      };
      meta: {
        next_lesson_id: number;
        prev_lesson_id: number;
      };
    };
  };
};

type fetchLessonVideoChaptersSuccess = {
  types: typeof FETCH_LESSON_VIDEO_CHAPTERS_SUCCESS;
  payload: {
    data: {
      data: {
        lesson: LessonVideoChapters;
      };
      meta: {
        next_lesson_id: number;
        prev_lesson_id: number;
      };
    };
  };
};

type fetchActiveLearningLessonSuccess = {
  types: typeof FETCH_LESSON_ACTIVE_LEARNING_SUCCESS;
  payload: {
    data: {
      data: {
        active_learning_lesson: IActiveLearningLesson;
      };
      meta: {
        next_lesson_id: number;
        prev_lesson_id: number;
      };
    };
  };
};

type fetchActiveLearningThemesSuccess = {
  types: typeof FETCH_ACTIVE_LEARNING_THEMES_SUCCESS;
  payload: {
    data: {
      data: IActiveLearningTheme[];
    };
  };
};

type fetchInitialDataFailure = {
  types: typeof FETCH_INITIAL_DATA_FAILURE;
  payload: {
    error: { message: string; field: string };
  };
};

type toggleCommentSuccess = {
  types: typeof TOGGLE_COMMENT_SUCCESS;
  payload: {
    params: { url: string };
    data: Record<string, unknown>;
  };
};

type createGroupSuccess = {
  types: typeof CREATE_GROUP_SUCCESS;
  payload: {
    data: Record<string, unknown>;
  };
};

type createGroupFailure = {
  types: typeof CREATE_GROUP_FAILURE;
  payload: {
    data: Record<string, unknown>;
  };
};

type bulkCreateGroupsSuccess = {
  types: typeof BULK_CREATE_GROUPS_SUCCESS;
  payload: {
    data: { ids: number[] };
  };
};

type bulkCreateGroupsFailure = {
  types: typeof BULK_CREATE_GROUPS_FAILURE;
  payload: {
    error: {
      message: string;
      status: number;
    };
  };
};

type updateGroupSuccess = {
  types: typeof UPDATE_GROUP_SUCCESS;
  payload: {
    data: { id: number; name: string };
  };
};

type updateGroupFailure = {
  types: typeof UPDATE_GROUP_FAILURE;
  payload: {
    data: Record<string, unknown>;
  };
};

type updateAnswerOpenFailure = {
  types: typeof ANSWER_OPENED_FAILURE;
  payload: {
    error: {
      message: string;
      status: number;
    };
  };
};

type updateNameOpenFailure = {
  types: typeof NAME_OPENED_FAILURE;
  payload: {
    error: {
      message: string;
      status: number;
    };
  };
};

type updateNameCloseFailure = {
  types: typeof NAME_CLOSED_FAILURE;
  payload: {
    error: {
      message: string;
      status: number;
    };
  };
};

type updateAnswerCloseFailure = {
  types: typeof ANSWER_CLOSED_FAILURE;
  payload: {
    error: {
      message: string;
      status: number;
    };
  };
};

type updatePasswordFailure = {
  types: typeof UPDATE_TEACHER_PASSWORD_FAILURE;
  payload: {
    error: Record<string, string>;
  };
};

type resetPasswordFailure = {
  types: typeof RESET_TEACHER_PASSWORD_FAILURE;
  payload: {
    error: Record<string, string>;
  };
};

type fetchStudentsSuccess = {
  types: typeof FETCH_STUDENTS_SUCCESS;
  payload: {
    data: { students: IStudent[] };
  };
};

type fetchAssessmentStudentsSuccess = {
  types: typeof FETCH_ASSESSMENT_STUDENTS_SUCCESS;
  payload: {
    data: {
      students: IAssessmentStudent[];
      class_scores: IClassScores;
      grade_scores: IReferenceScores;
      national_scores: IReferenceScores;
      is_exist_assessment_report: boolean;
      last_updated_at: string;
    };
  };
};

type fetchGroupsSuccess = {
  types: typeof FETCH_GROUPS_SUCCESS;
  payload: {
    data: { groups: IGroup[] };
  };
};

type fetchClassesSuccess = {
  types: typeof FETCH_CLASSES_SUCCESS;
  payload: {
    data: { classes: IClass[] };
  };
};

type fetchClassesByGradeSuccess = {
  types: typeof FETCH_CLASSES_BY_GRADE_SUCCESS;
  payload: {
    data: { classes: IClassWithStudents[] };
  };
};

type fetchKlassIdsWithActiveLearningMaterialsSuccess = {
  types: typeof FETCH_KLASS_IDS_WITH_ACTIVE_LEARNING_MATERIALS_SUCCESS;
  payload: {
    data: { classes: IClass[] };
  };
};

type createCommentSuccess = {
  types: typeof CREATE_COMMENT_SUCCESS;
  payload: {
    data: { answer_comment: IAnswerComment };
  };
};

type updateTeacherSurveySuccess = {
  types: typeof UPDATE_TEACHER_SURVEY_SUCCESS;
  payload: {
    data: ITeacherSurvey;
  };
};

type createTeacherSurveySuccess = {
  types: typeof CREATE_TEACHER_SURVEY_SUCCESS;
  payload: {
    data: ITeacherSurvey;
  };
};

type updateCommentSuccess = {
  types: typeof UPDATE_COMMENT_SUCCESS;
  payload: {
    data: { answer_comment: IAnswerComment; message: string };
  };
};

type deleteCommentSuccess = {
  types: typeof DELETE_COMMENT_SUCCESS;
  payload: {
    params: { url: string };
    data: { message: string };
  };
};

type fetchAnswersSuccess = {
  types: typeof FETCH_ANSWERS_SUCCESS;
  payload: {
    data: {
      data: {
        issue: {
          klasses: Array<{
            id: number;
            name: string;
            full_name: string;
            name_opened: boolean;
            answer_opened: boolean;
            answers: IAnswer[];
          }>;
        };
      };
    };
  };
};

type fetchAnswersFromOtherSchoolsSuccess = {
  types: typeof FETCH_ANSWERS_FROM_OTHER_SCHOOLS_SUCCESS;
  payload: {
    data: {
      issue: {
        classes: IAnswersFromOtherSchoolByClass[];
      };
    };
  };
};

type fetchAnswerSummariesSuccess = {
  types: typeof FETCH_ANSWER_SUMMARIES_SUCCESS;
  payload: {
    data: { teaching_materials: ITeachingMaterialAnswerSummary[] };
  };
};

type publishTeachingMaterialSuccess = {
  types: typeof PUBLISH_TEACHING_MATERIAL_SUCCESS;
  payload: {
    data: {
      teaching_material_id: number;
      class_id: number;
      opened: boolean;
    };
  };
};

type publishTeachingMaterialFailure = {
  types: typeof PUBLISH_TEACHING_MATERIAL_FAILURE;
  payload: {
    error: { message: string };
  };
};

type unpublishTeachingMaterialSuccess = {
  types: typeof UNPUBLISH_TEACHING_MATERIAL_SUCCESS;
  payload: {
    data: {
      teaching_material_id: number;
      class_id: number;
      opened: boolean;
    };
  };
};

type unpublishTeachingMaterialFailure = {
  types: typeof UNPUBLISH_TEACHING_MATERIAL_FAILURE;
  payload: {
    error: { message: string };
  };
};

type publishLessonSuccess = {
  types: typeof PUBLISH_LESSON_SUCCESS;
  payload: {
    data: {
      data: {
        lesson: {
          id: number;
          teaching_material_id: number;
          klass_id: number;
          published: boolean;
          issues: IIssue[];
        };
      };
    };
  };
};

type publishLessonFailure = {
  types: typeof PUBLISH_LESSON_FAILURE;
  payload: {
    error: { message: string };
  };
};

type unpublishLessonSuccess = {
  types: typeof UNPUBLISH_LESSON_SUCCESS;
  payload: {
    data: {
      data: {
        lesson: {
          id: number;
          teaching_material_id: number;
          klass_id: number;
          published: boolean;
          issues: IIssue[];
        };
      };
    };
  };
};

type unpublishLessonFailure = {
  types: typeof UNPUBLISH_LESSON_FAILURE;
  payload: {
    error: { message: string };
  };
};

type nameOpenedSuccess = {
  types: typeof NAME_OPENED_SUCCESS;
  payload: {
    data: {
      data: {
        issue: {
          lesson_id: number;
          issue_id: number;
          klass_id: number;
          name_opened: boolean;
        };
      };
    };
  };
};

type nameClosedSuccess = {
  types: typeof NAME_CLOSED_SUCCESS;
  payload: {
    data: {
      data: {
        issue: {
          lesson_id: number;
          issue_id: number;
          klass_id: number;
          name_opened: boolean;
        };
      };
    };
  };
};

type answerOpenedSuccess = {
  types: typeof ANSWER_OPENED_SUCCESS;
  payload: {
    data: {
      data: {
        issue: {
          lesson_id: number;
          issue_id: number;
          klass_id: number;
          answer_opened: boolean;
        };
      };
    };
  };
};

type answerClosedSuccess = {
  types: typeof ANSWER_CLOSED_SUCCESS;
  payload: {
    data: {
      data: {
        issue: {
          lesson_id: number;
          issue_id: number;
          klass_id: number;
          answer_opened: boolean;
        };
      };
    };
  };
};

type sendFeedbackCommentSuccess = {
  types: typeof SEND_FEEDBACK_COMMENT_SUCCESS;
  payload: {
    params: {
      feedback_comment: string;
    };
  };
};

type fetchPackagesSuccess = {
  types: typeof FETCH_PACKAGES_SUCCESS;
  payload: {
    params: { url: string };
    data: {
      data: {
        packages: IPackage[];
      };
    };
  };
};

type fetchSurveyAnswersSuccess = {
  types: typeof FETCH_SURVEY_ANSWERS_SUCCESS;
  payload: {
    params: { url: string };
    data: {
      survey_answers: ISurveyAnswers[];
      survey_answers_per_teaching_material: ISurveyAnswers[];
    };
  };
};

type fetchDetailsSurveySuccess = {
  types: typeof FETCH_DETAILS_SURVEY_SUCCESS;
  payload: {
    params: { url: string };
    data: {
      teaching_materials: IDetailsSurvey[];
    };
  };
};

type fetchAssessmentSuccess = {
  types: typeof FETCH_ASSESSMENT_SUCCESS;
  payload: {
    data: {
      student: {
        id: number;
        full_name: string;
      };
      assessment: IAssessmentTeacher;
      answers: IAssessmentAnswer[];
    };
  };
};

type fetchTemporaryTokenSuccess = {
  types: typeof FETCH_TEMPORARY_TOKEN_SUCCESS;
  payload: {
    data: {
      token: string;
    };
  };
};

type fetchAvgAssessmentSuccess = {
  types: typeof FETCH_AVERAGE_ASSESSMENT_SUCCESS;
  payload: {
    data: {
      avg_scores: {
        first_term_no_avg: IAssessmentAvgScores[] | null;
        previous_term_no_avg: IAssessmentAvgScores[] | null;
        last_term_no_avg: IAssessmentAvgScores[] | null;
      };
      distributions: IAssessmentDistribution[];
    };
  };
};

type fetchAvgAssessmentByGradeSuccess = {
  types: typeof FETCH_AVERAGE_ASSESSMENT_BY_GRADE_SUCCESS;
  payload: {
    data: {
      avg_scores: {
        first_term_no_avg: IAssessmentAvgScores[] | null;
        previous_term_no_avg: IAssessmentAvgScores[] | null;
        last_term_no_avg: IAssessmentAvgScores[] | null;
      };
    };
  };
};

type fetchOnePagePortfolioAssessmentSuccess = {
  types: typeof FETCH_ONE_PAGE_PORTFOLIO_ASSESSMENT_SUCCESS;
  payload: {
    data: {
      one_page_portfolio_assessment: OnePagePortfolioAssessment;
      reference_issues: ReferenceIssues[];
    };
  };
};

type fetchOnePagePortfolioAssessmentsSuccess = {
  types: typeof FETCH_ONE_PAGE_PORTFOLIO_ASSESSMENTS_SUCCESS;
  payload: {
    data: {
      one_page_portfolio_assessments: OnePagePortfolioAssessments[];
    };
  };
};

type deleteSuccess = {
  types: typeof DELETE_GROUP_SUCCESS;
  payload: {
    data: {
      id: number;
    };
  };
};

type fetchSchoolGoalsSuccess = {
  types: typeof FETCH_SCHOOL_GOALS_SUCCESS;
  payload: {
    data: {
      data: {
        school: ISchoolGoals;
      };
    };
  };
};

type updateAssessmentLastActiveSuccess = {
  types: typeof UPDATE_ASSESSMENT_LAST_ACTIVE_SUCCESS;
  payload: {
    data: { assessment_last_active_date: string | null };
  };
};

type updateAssessmentReportSuccess = {
  types: typeof UPDATE_ASSESSMENT_REPORT_SUCCESS;
  payload: {
    data: {
      is_exist_assessment_report: boolean;
      last_updated_at: string;
    };
  };
};

type resetStudentPasswordSuccess = {
  types: typeof RESET_STUDENT_PASSWORD_SUCCESS;
  payload: {
    data: { student: IStudent };
  };
};

type action503 = {
  types: typeof ACTION_503;
};

export type Actions =
  | ReturnType<typeof login>
  | ReturnType<typeof verifyMFA>
  | ReturnType<typeof logout>
  | ReturnType<typeof fetchInitialData>
  | ReturnType<typeof fetchTeachingMaterials>
  | ReturnType<typeof clearTeachingMaterials>
  | ReturnType<typeof fetchActiveLearningMaterials>
  | ReturnType<typeof fetchActiveLearningMaterialLessons>
  | ReturnType<typeof fetchActiveLearningMaterialLessonsData>
  | ReturnType<typeof fetchActiveLearningAnswers>
  | ReturnType<typeof fetchActiveLearningStudentAnswers>
  | ReturnType<typeof fetchActiveLearningMaterialAnswers>
  | ReturnType<typeof fetchActiveLearningThemes>
  | ReturnType<typeof fetchActiveLearningStoryBoard>
  | ReturnType<typeof fetchTeachingMaterial>
  | ReturnType<typeof fetchCountAnswers>
  | ReturnType<typeof fetchLessons>
  | ReturnType<typeof fetchLesson>
  | ReturnType<typeof fetchLessonVideoChapters>
  | ReturnType<typeof fetchActiveLearningLesson>
  | ReturnType<typeof fetchSchoolGoals>
  | ReturnType<typeof fetchStudents>
  | ReturnType<typeof fetchAssessmentStudents>
  | ReturnType<typeof fetchGroups>
  | ReturnType<typeof fetchClasses>
  | ReturnType<typeof fetchClassesByGrade>
  | ReturnType<typeof fetchKlassIdsWithActiveLearningMaterials>
  | ReturnType<typeof fetchCompletionStatuses>
  | ReturnType<typeof createGroup>
  | ReturnType<typeof bulkCreateGroups>
  | ReturnType<typeof updateGroup>
  | ReturnType<typeof fetchAnswers>
  | ReturnType<typeof fetchSimpleTeachingMaterials>
  | ReturnType<typeof createTeachingMaterialViewLog>
  | ReturnType<typeof createVideoChapterViewLog>
  | ReturnType<typeof fetchAnswerSummaries>
  | ReturnType<typeof fetchAvgAssessmentByGrade>
  | ReturnType<typeof createComment>
  | ReturnType<typeof updateTeacherSurvey>
  | ReturnType<typeof createTeacherSurvey>
  | ReturnType<typeof deleteComment>
  | ReturnType<typeof updateComment>
  | ReturnType<typeof publishTeachingMaterial>
  | ReturnType<typeof unpublishTeachingMaterial>
  | ReturnType<typeof nameOpened>
  | ReturnType<typeof nameClosed>
  | ReturnType<typeof updateTeacherPassword>
  | ReturnType<typeof updateTeacherSurveyShown>
  | ReturnType<typeof resetTeacherPassword>
  | ReturnType<typeof fetchDetailsSurvey>
  | ReturnType<typeof clearSuccessMessage>
  | ReturnType<typeof clearErrorMessage>
  | ReturnType<typeof clearOTT>
  | ReturnType<typeof fetchPackages>
  | ReturnType<typeof fetchSurveyAnswers>
  | ReturnType<typeof deleteGroup>
  | ReturnType<typeof toggleComment>
  | ReturnType<typeof fetchListLessons>
  | ReturnType<typeof fetchPortfolio>
  | ReturnType<typeof answerOpened>
  | ReturnType<typeof answerClosed>
  | ReturnType<typeof fetchDataDownloadCSV>
  | ReturnType<typeof fetchDownloadOppaCSV>
  | ReturnType<typeof publishLesson>
  | ReturnType<typeof unpublishLesson>
  | ReturnType<typeof fetchAnswersFromOtherSchools>
  | ReturnType<typeof sendFeedbackComment>
  | ReturnType<typeof fetchAssessment>
  | ReturnType<typeof fetchAssessmentPast>
  | ReturnType<typeof fetchDataAssessmentCSV>
  | ReturnType<typeof clearTemporaryToken>
  | ReturnType<typeof fetchAvgAssessment>
  | ReturnType<typeof fetchTemporaryToken>
  | ReturnType<typeof fetchAllDistributionsAssessment>
  | ReturnType<typeof updateAssessmentLastActive>
  | ReturnType<typeof clearStudents>
  | ReturnType<typeof getUuidStatus>
  | ReturnType<typeof postCompletedLesson>
  | ReturnType<typeof fetchLessonRetrospectives>
  | ReturnType<typeof postLessonRetrospectives>
  | ReturnType<typeof fetchOnePagePortfolioAssessment>
  | ReturnType<typeof fetchOnePagePortfolioAssessments>
  | ReturnType<typeof fetchTeachingHintsIntroductions>
  | ReturnType<typeof fetchNotificationTeachingHintsIntroductionLessonId>
  | ReturnType<typeof fetchTeachingHintsGroupWorks>
  | ReturnType<typeof fetchTeacherSurveyData>
  | loginSuccess
  | loginFailure
  | verifyMFASuccess
  | verifyMFAFailure
  | fetchInitialDataSuccess
  | fetchInitialDataFailure
  | fetchTeachingMaterialsSuccess
  | fetchActiveLearningMaterialsSuccess
  | fetchTeachingHintsIntroductionsSuccess
  | fetchNotificationTeachingHintsIntroductionsLessonIdSuccess
  | fetchTeachingHintsGroupWorksSuccess
  | fetchTeacherSurveySuccess
  | fetchActiveLearningMaterialAnswersSuccess
  | fetchActiveLearningMaterialLessonsSuccess
  | fetchActiveLearningMaterialLessonsDataSuccess
  | fetchActiveLearningAnswersSuccess
  | fetchActiveLearningStudentAnswersSuccess
  | fetchActiveLearningStoryBoardSuccess
  | fetchAnswersFromOtherSchoolsSuccess
  | fetchCountAnswersSuccess
  | fetchTeachingMaterialSuccess
  | sendFeedbackCommentSuccess
  | fetchAvgAssessmentByGradeSuccess
  | fetchLessonsSuccess
  | fetchSchoolGoalsSuccess
  | fetchSimpleTeachingMaterialsSuccess
  | createTeachingMaterialViewLogSuccess
  | createVideoChapterViewLogSuccess
  | fetchLessonSuccess
  | fetchLessonVideoChaptersSuccess
  | fetchActiveLearningLessonSuccess
  | fetchActiveLearningThemesSuccess
  | fetchStudentsSuccess
  | fetchAssessmentStudentsSuccess
  | fetchTemporaryTokenSuccess
  | fetchCompletionStatusesSuccess
  | fetchLessonRetrospectivesSuccess
  | answerOpenedSuccess
  | answerClosedSuccess
  | fetchGroupsSuccess
  | fetchClassesSuccess
  | fetchClassesByGradeSuccess
  | fetchKlassIdsWithActiveLearningMaterialsSuccess
  | createGroupSuccess
  | createGroupFailure
  | bulkCreateGroupsSuccess
  | bulkCreateGroupsFailure
  | updateGroupSuccess
  | updateGroupFailure
  | fetchAnswersSuccess
  | fetchAnswerSummariesSuccess
  | createCommentSuccess
  | updateTeacherSurveySuccess
  | createTeacherSurveySuccess
  | updateCommentSuccess
  | deleteCommentSuccess
  | updateNameOpenFailure
  | updateNameCloseFailure
  | publishTeachingMaterialSuccess
  | publishTeachingMaterialFailure
  | unpublishTeachingMaterialSuccess
  | unpublishTeachingMaterialFailure
  | nameOpenedSuccess
  | nameClosedSuccess
  | fetchSurveyAnswersSuccess
  | fetchPackagesSuccess
  | updateTeacherPasswordSuccess
  | updateTeacherSurveyShownSuccess
  | resetTeacherPasswordSuccess
  | resetPasswordFailure
  | updatePasswordFailure
  | updateAnswerOpenFailure
  | updateAnswerCloseFailure
  | deleteSuccess
  | toggleCommentSuccess
  | logoutSuccess
  | fetchDetailsSurveySuccess
  | fetchListLessonsSuccess
  | fetchPortfolioSuccess
  | fetchPortfolioFailure
  | fetchDataDownloadCSVSuccess
  | fetchDownloadOppaCSVSuccess
  | fetchDataAssessmentsCSVSuccess
  | publishLessonSuccess
  | publishLessonFailure
  | unpublishLessonSuccess
  | unpublishLessonFailure
  | fetchAssessmentSuccess
  | fetchAssessmentPastSuccess
  | fetchAvgAssessmentSuccess
  | fetchAllDistributionsAssessmentSuccess
  | updateAssessmentLastActiveSuccess
  | updateAssessmentReportSuccess
  | postCompletedLessonSuccess
  | postLessonRetrospectivesSuccess
  | fetchOnePagePortfolioAssessmentSuccess
  | fetchOnePagePortfolioAssessmentsSuccess
  | resetStudentPasswordSuccess
  | checkUuidSuccess
  | checkUuidFailure
  | action503;

export type AppState = {
  session_id: string;
  school?: ISchoolCountAnswers;
  error: string;
  error_field: string;
  success_message: string;
  isServiceUnavailable: boolean;
  isLoaderVisible: boolean;
  teaching_materials: ITeachingMaterial[];
  active_learning_materials: IActiveLearningMaterial[];
  active_learning_material_lessons: IActiveLearningMaterialLessons;
  active_learning_material_lessons_data: IActiveLearningMaterialLessonsData[];
  active_learning_answers: IActiveLearningKlassStudentAnswers[] | null;
  active_learning_student_answers: IActiveLearningStudentAnswers | null;
  active_learning_themes: IActiveLearningTheme[];
  active_learning_story_board: IActiveLearningStoryBoard;
  active_learning_material_answers: IActiveLearningMaterialAnswers[];
  simple_teaching_materials: ISimpleTeachingMaterial[];
  teaching_material?: ITeachingMaterial;
  lessonsByTeachingMaterial?: ILessonByTeachingMaterial[];
  lessons: ILesson[];
  school_goals: ISchoolGoals;
  lesson?: ILesson;
  lesson_video_chapters?: LessonVideoChapters;
  activeLearningLesson?: IActiveLearningLesson;
  teacher: ITeacher;
  students: IStudent[];
  assessmentStudents: IAssessmentStudent[];
  classes: IClass[];
  classes_by_grade: IClassWithStudents[];
  klass_ids_with_active_learning_materials: IClass[];
  groups: IGroup[];
  answersByClasses: IAnswersByClass[];
  packages: IPackage[];
  survey_answers: ISurveyAnswers[];
  survey_answers_per_teaching_material: ISurveyAnswers[];
  teaching_material_answer_summaries: ITeachingMaterialAnswerSummary[];
  details_survey: IDetailsSurvey[] | null;
  lessonCSV?: ILessonCSV;
  onePagePortfolioAssessmentCSV?: IOnePagePortfolioAssessmentCSVData;
  assessmentsCSV: IAssessmentCSV[];
  next_lesson_id: number | null;
  prev_lesson_id: number | null;
  school_name: string;
  assessment: IAssessmentTeacher;
  assessmentStudent: {
    id: number;
    full_name: string;
  };
  assessmentAnswers: IAssessmentAnswer[];
  assessment_avg_scores: IAssessmentAvgScores[] | null;
  past_assessment_avg_scores: {
    first_assessment_avg_scores: IAssessmentAvgScores[] | null;
    previous_assessment_avg_scores: IAssessmentAvgScores[] | null;
  };
  assessment_avg_scores_by_grade: IAssessmentAvgScores[] | null;
  past_assessment_avg_scores_by_grade: {
    first_assessment_avg_scores: IAssessmentAvgScores[] | null;
    previous_assessment_avg_scores: IAssessmentAvgScores[] | null;
  };
  distributions: IAssessmentDistribution[];
  survey_enabled: boolean;
  teacher_survey_shown: boolean;
  teacher_survey_enabled: boolean;
  available_item_codes: string[];
  is_manager: boolean;
  only_assessment: boolean;
  lastAction: string;
  max_term_no_by_grade: number;
  assessments_past: IAssessment[];
  answersOtherSchoolsByClasses: IAnswersFromOtherSchoolByClass[];
  allDistributions: IAllDistributions;
  temporaryToken: string | null;
  portfolio: IPortfolio | null;
  ott: string;
  isUuidExpired: boolean;
  expires: Date;
  is_any_unread_news: boolean;
  assessmentReferenceScores: {
    classScores: IClassScores | null;
    gradeScores: IReferenceScores | null;
    nationalScores: IReferenceScores | null;
    isExistAssessmentReport: boolean;
    lastUpdatedAt: Date;
  };
  completion_statuses: ICompletionStatuses;
  teacher_lesson_retrospectives: ITeacherLessonRetrospectives;
  lesson_completed: string;
  one_page_portfolio_assessment: OnePagePortfolioAssessment | null;
  one_page_portfolio_assessments: OnePagePortfolioAssessments[];
  reference_issues: ReferenceIssues[] | null;
  teaching_hint_introduction: ITeachingHintsIntroductions | null;
  notification_teaching_hint_introduction_lesson_id: number | null;
  teaching_hint_group_work: ITeachingHintsGroupWorks | null;
  teacher_survey: ITeacherSurvey | null;
  has_base: boolean;
  current_year: number;
  has_g4s_order: boolean;
  has_g4s_basic_order: boolean;
  has_dlp_order: boolean;
};

export const InitialAppState: AppState = {
  session_id: "",
  error: "",
  error_field: "",
  success_message: "",
  isServiceUnavailable: false,
  isLoaderVisible: false,
  teaching_materials: [],
  active_learning_materials: [],
  active_learning_material_lessons: {
    material_code: "",
    no: NaN,
    title: "",
    issues: [],
  },
  active_learning_material_lessons_data: [],
  active_learning_answers: null,
  active_learning_student_answers: null,
  active_learning_themes: [],
  active_learning_story_board: {
    id: NaN,
    enageed_theme_name: "",
    image_urls: [],
  },
  active_learning_material_answers: [],
  simple_teaching_materials: [],
  lessons: [],
  school_goals: {
    id: 0,
    purpose: "",
    specific_state: "",
    theme: "",
  },
  students: [],
  assessmentStudents: [],
  groups: [],
  classes: [],
  classes_by_grade: [],
  klass_ids_with_active_learning_materials: [],
  teacher: {
    id: 0,
    name: "",
    classes: [],
    class_ids: [],
    email: "",
    first_name: "",
    last_name: "",
    first_name_kana: "",
    last_name_kana: "",
    read_last_notification_id: 0,
    school_id: 0,
    serviced: false,
  },
  answersByClasses: [],
  packages: [],
  survey_answers: [],
  survey_answers_per_teaching_material: [],
  teaching_material_answer_summaries: [],
  details_survey: null,
  lessonCSV: undefined,
  onePagePortfolioAssessmentCSV: undefined,
  assessmentsCSV: [],
  next_lesson_id: null,
  prev_lesson_id: null,
  school_name: "",
  assessment: {
    id: 0,
    assessment_experiences: [],
    current_assessment_next_actions: [],
    past_assessment_next_actions: [],
    term_no: 0,
    feedback_comment: null,
    created_at: "",
    reasons: [],
  },
  assessmentStudent: {
    id: 0,
    full_name: "",
  },
  assessmentAnswers: [],
  assessment_avg_scores: null,
  past_assessment_avg_scores: {
    first_assessment_avg_scores: null,
    previous_assessment_avg_scores: null,
  },
  assessment_avg_scores_by_grade: null,
  past_assessment_avg_scores_by_grade: {
    first_assessment_avg_scores: null,
    previous_assessment_avg_scores: null,
  },
  distributions: [],
  survey_enabled: false,
  teacher_survey_shown: false,
  teacher_survey_enabled: false,
  available_item_codes: [],
  is_manager: false,
  only_assessment: false,
  lastAction: "",
  max_term_no_by_grade: 0,
  assessments_past: [],
  answersOtherSchoolsByClasses: [],
  allDistributions: {
    first_term_no_distributions: null,
    last_term_no_distributions: null,
    previous_term_no_distributions: null,
  },
  temporaryToken: null,
  portfolio: null,
  ott: "",
  isUuidExpired: false,
  expires: addHours(new Date(), 6),
  is_any_unread_news: false,
  assessmentReferenceScores: {
    classScores: null,
    gradeScores: null,
    nationalScores: null,
    isExistAssessmentReport: false,
    lastUpdatedAt: new Date(),
  },
  completion_statuses: {
    lesson_id: NaN,
    completion_statuses: [],
  },
  teacher_lesson_retrospectives: {
    id: NaN,
    teacher_id: NaN,
    class_ids: "",
    lesson_id: NaN,
    score: 0,
    lesson_delivery_score: 0,
    group_work_score: null,
    memo: "",
  },
  lesson_completed: "",
  one_page_portfolio_assessment: null,
  one_page_portfolio_assessments: [],
  reference_issues: null,
  teaching_hint_introduction: null,
  notification_teaching_hint_introduction_lesson_id: null,
  teaching_hint_group_work: null,
  teacher_survey: null,
  has_base: false,
  current_year: 0,
  has_g4s_order: false,
  has_g4s_basic_order: false,
  has_dlp_order: false,
};

function isLoginMFA(
  data: ILoginResponse | ILoginMFAResponse,
): data is ILoginMFAResponse {
  return (data as ILoginMFAResponse).ott !== undefined;
}

export const reducer = (state: AppState, action: Actions): AppState => {
  const newState = { ...state, lastAction: action.types };
  switch (action.types) {
    case LOGIN_SUCCESS: {
      if (isLoginMFA(action.payload.data)) {
        const { ott } = action.payload.data;
        return {
          ...newState,
          error: "",
          error_field: "",
          ott,
        };
      }
      const {
        session_id,
        teacher,
        is_manager,
        only_assessment,
        current_year,
      } = action.payload.data;
      return {
        ...newState,
        error: "",
        error_field: "",
        session_id,
        teacher,
        is_manager,
        only_assessment,
        current_year,
      };
    }
    case VERIFY_MFA_SUCCESS: {
      const {
        session_id,
        teacher,
        is_manager,
        only_assessment,
        current_year,
      } = action.payload.data;
      return {
        ...newState,
        error: "",
        error_field: "",
        session_id,
        teacher,
        is_manager,
        only_assessment,
        current_year,
      };
    }
    case VERIFY_MFA_FAILURE: {
      const { message, field } = action.payload.error;
      return {
        ...newState,
        error: message,
        error_field: field,
      };
    }
    case FETCH_INITIAL_DATA: {
      return { ...newState };
    }
    case FETCH_INITIAL_DATA_SUCCESS: {
      const {
        teacher,
        school_name,
        survey_enabled,
        teacher_survey_shown,
        teacher_survey_enabled,
        available_item_codes,
        is_manager,
        only_assessment,
        is_any_unread_news,
        has_base,
        current_year,
        has_g4s_order,
        has_g4s_basic_order,
        has_dlp_order,
      } = action.payload.data;
      return {
        ...newState,
        error: "",
        error_field: "",
        teacher: {
          ...teacher,
          assessment_last_active_date: teacher.assessment_last_active_date
            ? new Date(teacher.assessment_last_active_date)
            : null,
        },
        school_name,
        session_id: teacher.id ? state.session_id : "",
        survey_enabled,
        teacher_survey_shown,
        teacher_survey_enabled,
        available_item_codes,
        is_manager,
        only_assessment,
        is_any_unread_news,
        has_base,
        current_year,
        has_g4s_order,
        has_g4s_basic_order,
        has_dlp_order,
      };
    }
    case UPDATE_ASSESSMENT_LAST_ACTIVE_SUCCESS: {
      const { assessment_last_active_date } = action.payload.data;
      return {
        ...newState,
        error: "",
        error_field: "",
        teacher: {
          ...(state.teacher as ITeacher),
          assessment_last_active_date: assessment_last_active_date
            ? new Date(assessment_last_active_date)
            : null,
        },
      };
    }
    case UPDATE_ASSESSMENT_REPORT_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        assessmentReferenceScores: {
          ...newState.assessmentReferenceScores,
          isExistAssessmentReport: data.is_exist_assessment_report,
          lastUpdatedAt: new Date(data.last_updated_at ?? ""),
        },
      };
    }
    case FETCH_LIST_LESSONS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        error: "",
        error_field: "",
        lessonsByTeachingMaterial: data.lessons,
      };
    }
    case FETCH_PORTFOLIO: {
      return {
        ...newState,
        portfolio: null,
      };
    }
    case FETCH_PORTFOLIO_SUCCESS: {
      const { portfolio } = action.payload.data;
      return {
        ...newState,
        error: "",
        error_field: "",
        portfolio,
      };
    }
    case FETCH_PORTFOLIO_FAILURE: {
      return {
        ...newState,
        error: action.payload.error.message,
        error_field: "",
        success_message: "",
      };
    }
    case UPDATE_TEACHER_PASSWORD_SUCCESS: {
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: UPDATE_TEACHER_PASSWORD_SUCCESS_MESSAGE,
      };
    }
    case UPDATE_TEACHER_SURVEY_SHOWN_SUCCESS: {
      return {
        ...newState,
        teacher_survey_shown: true,
      };
    }
    case RESET_TEACHER_PASSWORD_SUCCESS: {
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: RESET_TEACHER_PASSWORD_SUCCESS_MESSAGE,
      };
    }
    case TOGGLE_COMMENT_SUCCESS: {
      const paths = action.payload.params.url.split("/");
      const comment_id = Number(paths[paths.length - 2]);

      return {
        ...newState,
        answersByClasses: state.answersByClasses.map(k => ({
          ...k,
          answers: k.answers.map(a => ({
            ...a,
            comments: a.comments.map(c => ({
              ...c,
              hidden_by:
                c.id !== comment_id
                  ? c.hidden_by
                  : c.hidden_by !== null
                  ? null
                  : state.teacher,
            })),
          })),
        })),
        success_message: TOGGLE_COMMENT_SUCCESS_MSG,
      };
    }
    case CREATE_GROUP_SUCCESS: {
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: CREATE_GROUP_SUCCESS_MESSAGE,
      };
    }
    case BULK_CREATE_GROUPS_SUCCESS: {
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: BULK_CREATE_GROUPS_SUCCESS_MESSAGE,
      };
    }
    case CHECK_UUID:
    case CHECK_UUID_SUCCESS: {
      return {
        ...newState,
        isUuidExpired: false,
      };
    }
    case FETCH_TEACHING_HINT_INTRODUCTIONS: {
      return {
        ...newState,
        teaching_hint_introduction: null,
      };
    }
    case FETCH_TEACHING_HINT_INTRODUCTIONS_SUCCESS: {
      return {
        ...newState,
        teaching_hint_introduction: action.payload.data,
      };
    }

    case FETCH_NOTIFICATION_TEACHING_HINT_INTRODUCTIONS_LESSON_ID: {
      return {
        ...newState,
        notification_teaching_hint_introduction_lesson_id: null,
      };
    }
    case FETCH_NOTIFICATION_TEACHING_HINT_INTRODUCTIONS_LESSON_ID_SUCCESS: {
      return {
        ...newState,
        notification_teaching_hint_introduction_lesson_id:
          action.payload.data.lesson_id,
      };
    }

    case FETCH_TEACHING_HINT_GROUP_WORKS: {
      return {
        ...newState,
        teaching_hint_group_work: null,
      };
    }
    case FETCH_TEACHING_HINT_GROUP_WORKS_SUCCESS: {
      return {
        ...newState,
        teaching_hint_group_work: action.payload.data,
      };
    }
    case FETCH_TEACHER_SURVEY: {
      return {
        ...newState,
        teacher_survey: null,
      };
    }
    case FETCH_TEACHER_SURVEY_SUCCESS: {
      return {
        ...newState,
        teacher_survey: action.payload.data.teacher_survey,
        teacher_survey_shown: action.payload.data.teacher_survey_shown,
      };
    }

    case CREATE_GROUP_FAILURE: {
      return {
        ...newState,
        error: CREATE_GROUP_FAILURE_MESSAGE,
        error_field: "",
        success_message: "",
      };
    }
    case BULK_CREATE_GROUPS_FAILURE: {
      return {
        ...newState,
        error: action.payload.error.message,
        error_field: "",
        success_message: "",
      };
    }
    case UPDATE_TEACHER_PASSWORD_FAILURE: {
      const { error } = action.payload;
      return {
        ...newState,
        error: error.message,
        error_field: "",
        success_message: "",
      };
    }
    case RESET_TEACHER_PASSWORD_FAILURE: {
      const { error } = action.payload;
      return {
        ...newState,
        error: error.message || RESET_TEACHER_PASSWORD_FAILURE_MESSAGE,
        error_field: "",
        success_message: "",
      };
    }
    case CHECK_UUID_FAILURE: {
      return {
        ...newState,
        isUuidExpired: true,
      };
    }
    case UPDATE_GROUP_SUCCESS: {
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: UPDATE_GROUP_SUCCESS_MESSAGE,
        groups: state.groups!.map(g =>
          g.id === action.payload.data.id
            ? {
                ...g,
                name: action.payload.data.name,
              }
            : g,
        ),
      };
    }
    case UPDATE_GROUP_FAILURE: {
      return {
        ...newState,
        error: UPDATE_GROUP_FAILURE_MESSAGE,
        error_field: "",
        success_message: "",
      };
    }
    case FETCH_DATA_DOWNLOAD_CSV_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        error: "",
        error_field: "",
        lessonCSV: data.lesson,
      };
    }
    case FETCH_DOWNLOAD_OPPA_CSV_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        error: "",
        error_field: "",
        onePagePortfolioAssessmentCSV: data,
      };
    }
    case FETCH_DATA_ASSESSMENTS_CSV: {
      return {
        ...newState,
        assessmentsCSV: [],
      };
    }
    case FETCH_DATA_ASSESSMENTS_CSV_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        assessmentsCSV: data.assessments,
      };
    }
    case FETCH_ANSWERS_FROM_OTHER_SCHOOLS_SUCCESS: {
      const { issue } = action.payload.data;
      return {
        ...newState,
        error: "",
        error_field: "",
        answersOtherSchoolsByClasses: issue.classes,
      };
    }
    case FETCH_COUNT_ANSWERS_SUCCESS: {
      const { school } = action.payload.data.data;
      return {
        ...newState,
        error: "",
        error_field: "",
        school,
      };
    }
    case FETCH_TEACHING_MATERIAL_SUCCESS: {
      const t = action.payload.data.data.teaching_material;
      return {
        ...newState,
        error: "",
        error_field: "",
        teaching_material: {
          ...t,
        },
      };
    }
    case FETCH_TEACHING_MATERIALS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        teaching_materials: [...data.data.teaching_materials],
        lesson: undefined,
      };
    }
    case FETCH_ACTIVE_LEARNING_MATERIALS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        active_learning_materials: [...data.data.active_learning_materials],
      };
    }
    case FETCH_ACTIVE_LEARNING_MATERIAL_ANSWERS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        active_learning_material_answers: data.data,
      };
    }
    case FETCH_ACTIVE_LEARNING_MATERIAL_LESSONS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        active_learning_material_lessons: data.data,
      };
    }
    case FETCH_ACTIVE_LEARNING_MATERIAL_LESSONS_DATA_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        active_learning_material_lessons_data: data.data,
      };
    }
    case FETCH_ACTIVE_LEARNING_ANSWERS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        active_learning_answers: data.students,
      };
    }
    case FETCH_ACTIVE_LEARNING_STUDENT_ANSWERS_SUCCESS: {
      return {
        ...newState,
        active_learning_student_answers: action.payload.data.student,
      };
    }
    case FETCH_ACTIVE_LEARNING_STORY_BOARD_SUCCESS: {
      const { data } = action.payload.data;
      return {
        ...newState,
        active_learning_story_board: data,
      };
    }
    case FETCH_ACTIVE_LEARNING_THEMES_SUCCESS: {
      const { data } = action.payload.data;
      return {
        ...newState,
        active_learning_themes: data,
      };
    }
    case CLEAR_TEACHING_MATERIALS: {
      return {
        ...newState,
        teaching_materials: [],
      };
    }
    case FETCH_SIMPLE_TEACHING_MATERIALS_SUCCESS: {
      const { teaching_materials } = action.payload.data;
      return {
        ...newState,
        simple_teaching_materials: teaching_materials,
      };
    }
    case CREATE_TEACHING_MATERIAL_VIEW_LOG_SUCCESS: {
      return { ...newState };
    }
    case CREATE_VIDEO_CHAPTER_VIEW_LOG_SUCCESS: {
      return { ...newState };
    }
    case FETCH_LESSONS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        lessons: data.lessons,
      };
    }
    case FETCH_SCHOOL_GOALS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        school_goals: data.data.school,
      };
    }
    case FETCH_ONE_PAGE_PORTFOLIO_ASSESSMENT_SUCCESS: {
      const {
        one_page_portfolio_assessment,
        reference_issues,
      } = action.payload.data;
      return {
        ...newState,
        one_page_portfolio_assessment,
        reference_issues,
      };
    }
    case FETCH_ONE_PAGE_PORTFOLIO_ASSESSMENTS_SUCCESS: {
      const { one_page_portfolio_assessments } = action.payload.data;
      return {
        ...newState,
        one_page_portfolio_assessments,
      };
    }
    case ANSWER_CLOSED_SUCCESS:
    case ANSWER_OPENED_SUCCESS: {
      const { klass_id, answer_opened } = action.payload.data.data.issue;
      return {
        ...newState,
        answersByClasses: state.answersByClasses.map(k => ({
          ...k,
          answer_opened: k.id === klass_id ? answer_opened : k.answer_opened,
        })),
      };
    }
    case ANSWER_OPENED_FAILURE: {
      return {
        ...newState,
        error: TOGGLE_ANSWER_ERROR_MSG,
        error_field: "",
        success_message: "",
      };
    }
    case NAME_OPENED_SUCCESS:
    case NAME_CLOSED_SUCCESS: {
      const { klass_id, name_opened } = action.payload.data.data.issue;
      return {
        ...newState,
        answersByClasses: state.answersByClasses.map(k => ({
          ...k,
          name_opened: k.id === klass_id ? name_opened : k.name_opened,
        })),
      };
    }
    case NAME_CLOSED_FAILURE: {
      return {
        ...newState,
        error: TOGGLE_ANSWER_ERROR_MSG,
        error_field: "",
        success_message: "",
      };
    }
    case NAME_OPENED_FAILURE: {
      return {
        ...newState,
        error: TOGGLE_ANSWER_ERROR_MSG,
        error_field: "",
        success_message: "",
      };
    }
    case ANSWER_CLOSED_FAILURE: {
      return {
        ...newState,
        error: TOGGLE_ANSWER_ERROR_MSG,
        error_field: "",
        success_message: "",
      };
    }
    case FETCH_LESSON_SUCCESS: {
      const { data, meta } = action.payload.data;
      return {
        ...newState,
        next_lesson_id: meta.next_lesson_id,
        prev_lesson_id: meta.prev_lesson_id,
        lesson: data.lesson,
      };
    }
    case FETCH_LESSON_VIDEO_CHAPTERS_SUCCESS: {
      const { data, meta } = action.payload.data;
      return {
        ...newState,
        next_lesson_id: meta.next_lesson_id,
        prev_lesson_id: meta.prev_lesson_id,
        lesson_video_chapters: data.lesson,
      };
    }
    case FETCH_LESSON_ACTIVE_LEARNING_SUCCESS: {
      const { data, meta } = action.payload.data;
      return {
        ...newState,
        next_lesson_id: meta.next_lesson_id,
        prev_lesson_id: meta.prev_lesson_id,
        activeLearningLesson: data.active_learning_lesson,
      };
    }
    case FETCH_STUDENTS_SUCCESS: {
      return { ...newState, students: action.payload.data.students };
    }
    case FETCH_ASSESSMENT_STUDENTS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        assessmentStudents: data.students,
        assessmentReferenceScores: {
          classScores: data.class_scores,
          gradeScores: data.grade_scores,
          nationalScores: data.national_scores,
          isExistAssessmentReport: data.is_exist_assessment_report,
          lastUpdatedAt: new Date(data.last_updated_at ?? ""),
        },
      };
    }
    case FETCH_ALL_DISTRIBUTIONS_ASSESSMENT_SUCCESS: {
      return {
        ...newState,
        allDistributions: action.payload.data.all_distributions,
      };
    }
    case FETCH_GROUPS_SUCCESS: {
      return { ...newState, groups: action.payload.data.groups };
    }
    case FETCH_CLASSES_SUCCESS: {
      return { ...newState, classes: action.payload.data.classes };
    }
    case FETCH_CLASSES_BY_GRADE_SUCCESS: {
      return { ...newState, classes_by_grade: action.payload.data.classes };
    }
    case FETCH_KLASS_IDS_WITH_ACTIVE_LEARNING_MATERIALS_SUCCESS: {
      return {
        ...newState,
        klass_ids_with_active_learning_materials: action.payload.data.classes,
      };
    }
    case FETCH_ANSWERS_SUCCESS: {
      return {
        ...newState,
        answersByClasses: action.payload.data.data.issue.klasses,
      };
    }
    case FETCH_ANSWER_SUMMARIES_SUCCESS: {
      return {
        ...newState,
        teaching_material_answer_summaries:
          action.payload.data.teaching_materials,
      };
    }
    case FETCH_COMPLETION_STATUSES_SUCCESS: {
      return {
        ...newState,
        completion_statuses: action.payload.data,
      };
    }
    case FETCH_LESSON_RETROSPECTIVES_SUCCESS: {
      return {
        ...newState,
        teacher_lesson_retrospectives:
          action.payload.data.teacher_lesson_retrospective,
      };
    }
    case POST_LESSON_COMPLETED_SUCCESS: {
      return {
        ...newState,
        lesson_completed: action.payload.data.message,
      };
    }
    case UPDATE_TEACHER_SURVEY_SUCCESS: {
      return {
        ...newState,
        teacher_survey: action.payload.data,
      };
    }
    case CREATE_TEACHER_SURVEY_SUCCESS: {
      return {
        ...newState,
        teacher_survey: action.payload.data,
      };
    }
    case CREATE_COMMENT_SUCCESS: {
      return {
        ...newState,
        answersByClasses: state.answersByClasses.map(k => ({
          ...k,
          answers: k.answers.map(a =>
            a.id === action.payload.data.answer_comment.answer_id
              ? {
                  ...a,
                  comments: [
                    ...a.comments,
                    {
                      ...action.payload.data.answer_comment,
                      updated_at: new Date(
                        action.payload.data.answer_comment.updated_at,
                      ),
                      hidden_by: null,
                    },
                  ],
                }
              : a,
          ),
        })),
        success_message: CREATE_COMMENT_SUCCESS_MSG,
      };
    }
    case CREATE_COMMENT:
    case UPDATE_COMMENT:
    case TOGGLE_COMMENT:
    case DELETE_COMMENT: {
      return newState;
    }
    case UPDATE_COMMENT_SUCCESS: {
      return {
        ...newState,
        answersByClasses: state.answersByClasses.map(k => ({
          ...k,
          answers: k.answers.map(a =>
            a.id === action.payload.data.answer_comment.answer_id
              ? {
                  ...a,
                  comments: a.comments.map(c =>
                    c.id === action.payload.data.answer_comment.id
                      ? {
                          ...c,
                          content: action.payload.data.answer_comment.content,
                        }
                      : c,
                  ),
                }
              : a,
          ),
        })),
        success_message: UPDATE_COMMENT_SUCCESS_MSG,
      };
    }
    case DELETE_COMMENT_SUCCESS: {
      const paths = action.payload.params.url.split("/");
      const comment_id = Number(paths[paths.length - 1]);

      return {
        ...newState,
        answersByClasses: state.answersByClasses.map(k => ({
          ...k,
          answers: k.answers.map(a => ({
            ...a,
            comments: a.comments.filter(c => c.id !== comment_id),
          })),
        })),
        success_message: DELETE_COMMENT_SUCCESS_MSG,
      };
    }
    case PUBLISH_TEACHING_MATERIAL_FAILURE: {
      return {
        ...newState,
        error: action.payload.error.message,
        error_field: "",
        success_message: "",
      };
    }
    case PUBLISH_TEACHING_MATERIAL_SUCCESS: {
      const { teaching_material_id } = action.payload.data;
      return {
        ...newState,
        teaching_materials: state.teaching_materials.map(t => {
          if (t.id === teaching_material_id) {
            return {
              ...t,
              opened: true,
              lessons: t.lessons?.map(lesson => ({
                ...lesson,
                published: true,
                issues: lesson.issues?.map(issue => ({
                  ...issue,
                  answer_opened: true,
                })),
              })),
            };
          }
          return t;
        }),
        success_message: PUBLISH_TEACHING_MATERIAL_SUCCESS_MSG,
      };
    }
    case UNPUBLISH_TEACHING_MATERIAL_FAILURE: {
      return {
        ...newState,
        error: action.payload.error.message,
        error_field: "",
        success_message: "",
      };
    }
    case UNPUBLISH_TEACHING_MATERIAL_SUCCESS: {
      const { teaching_material_id } = action.payload.data;
      return {
        ...newState,
        teaching_materials: state.teaching_materials.map(t => {
          if (t.id === teaching_material_id) {
            return {
              ...t,
              opened: false,
              lessons: t.lessons?.map(lesson => ({
                ...lesson,
                published: false,
                issues: lesson.issues?.map(issue => ({
                  ...issue,
                  answer_opened: false,
                  name_opened: false,
                })),
              })),
            };
          }
          return t;
        }),
        success_message: UNPUBLISH_TEACHING_MATERIAL_SUCCESS_MSG,
      };
    }
    case UNPUBLISH_LESSON_FAILURE: {
      return {
        ...newState,
        error: action.payload.error.message,
        error_field: "",
        success_message: "",
      };
    }
    case UNPUBLISH_LESSON_SUCCESS: {
      const {
        id,
        teaching_material_id,
        published,
        issues,
      } = action.payload.data.data.lesson;
      return {
        ...newState,
        teaching_materials: state.teaching_materials.map(t =>
          t.id === teaching_material_id
            ? {
                ...t,
                lessons: t.lessons?.map(lesson =>
                  lesson.id === id
                    ? {
                        ...lesson,
                        published,
                        issues,
                      }
                    : lesson,
                ),
              }
            : t,
        ),
        success_message: UNPUBLISH_LESSON_SUCCESS_MSG,
      };
    }
    case PUBLISH_LESSON_FAILURE: {
      return {
        ...newState,
        error: action.payload.error.message,
        error_field: "",
        success_message: "",
      };
    }
    case PUBLISH_LESSON_SUCCESS: {
      const {
        id,
        teaching_material_id,
        published,
        issues,
      } = action.payload.data.data.lesson;
      return {
        ...newState,
        teaching_materials: state.teaching_materials.map(t =>
          t.id === teaching_material_id
            ? {
                ...t,
                opened: true,
                lessons: t.lessons?.map(lesson =>
                  lesson.id === id
                    ? {
                        ...lesson,
                        published,
                        issues,
                      }
                    : lesson,
                ),
              }
            : t,
        ),
        success_message: PUBLISH_LESSON_SUCCESS_MSG,
      };
    }
    case SEND_FEEDBACK_COMMENT_SUCCESS: {
      const { feedback_comment } = action.payload.params;
      return {
        ...newState,
        assessment: {
          ...state.assessment,
          feedback_comment,
        },
        success_message: SEND_FEEDBACK_COMMENT_SUCCESS_MSG,
      };
    }
    case DELETE_GROUP_SUCCESS: {
      const groupId = action.payload.data.id;
      return {
        ...newState,
        groups: state.groups.filter(group => group.id !== groupId),
      };
    }
    case FETCH_PACKAGES_SUCCESS: {
      return {
        ...newState,
        packages: action.payload.data.data.packages,
      };
    }
    case FETCH_SURVEY_ANSWERS_SUCCESS: {
      return {
        ...newState,
        survey_answers: action.payload.data.survey_answers,
        survey_answers_per_teaching_material:
          action.payload.data.survey_answers_per_teaching_material,
      };
    }
    case FETCH_DETAILS_SURVEY_SUCCESS: {
      return {
        ...newState,
        details_survey: action.payload.data.teaching_materials,
      };
    }
    case FETCH_ASSESSMENT_SUCCESS: {
      const { assessment, student, answers } = action.payload.data;
      return {
        ...newState,
        assessment,
        assessmentStudent: student,
        assessmentAnswers: answers,
      };
    }
    case FETCH_ASSESSMENT: {
      return {
        ...newState,
        assessment: {
          id: 0,
          assessment_experiences: [],
          current_assessment_next_actions: [],
          past_assessment_next_actions: [],
          term_no: 0,
          feedback_comment: null,
          created_at: "",
          reasons: [],
        },
        assessmentStudent: {
          id: 0,
          full_name: "",
        },
        assessmentAnswers: [],
      };
    }
    case FETCH_ASSESSMENT_PAST_SUCCESS: {
      const { assessments } = action.payload.data;
      return {
        ...newState,
        assessments_past: assessments,
      };
    }
    case FETCH_TEMPORARY_TOKEN_SUCCESS: {
      return {
        ...newState,
        temporaryToken: action.payload.data.token,
      };
    }
    case CLEAR_TEMPORARY_TOKEN: {
      return {
        ...newState,
        temporaryToken: null,
      };
    }
    case FETCH_AVERAGE_ASSESSMENT_SUCCESS: {
      const { avg_scores, distributions } = action.payload.data;
      return {
        ...newState,
        assessment_avg_scores: avg_scores.last_term_no_avg,
        past_assessment_avg_scores: {
          first_assessment_avg_scores: avg_scores.first_term_no_avg,
          previous_assessment_avg_scores: avg_scores.previous_term_no_avg,
        },
        distributions,
      };
    }
    case FETCH_AVERAGE_ASSESSMENT_BY_GRADE_SUCCESS: {
      const { avg_scores } = action.payload.data;
      return {
        ...newState,
        assessment_avg_scores_by_grade: avg_scores.last_term_no_avg,
        past_assessment_avg_scores_by_grade: {
          first_assessment_avg_scores: avg_scores.first_term_no_avg,
          previous_assessment_avg_scores: avg_scores.previous_term_no_avg,
        },
      };
    }
    case RESET_STUDENT_PASSWORD_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: RESET_STUDENT_PASSWORD_SUCCESS_MESSAGE,
        students: state.students.map(s =>
          s.id === data.student.id ? data.student : s,
        ),
      };
    }
    case CLEAR_OTT: {
      return { ...newState, ott: "" };
    }
    case CLEAR_STUDENTS: {
      return {
        ...newState,
        students: [],
      };
    }
    case FETCH_INITIAL_DATA_FAILURE: {
      return { ...InitialAppState };
    }
    case LOGIN_FAILURE:
      return {
        ...newState,
        error: action.payload.error.message,
        error_field: action.payload.error.field,
      };
    case LOGOUT:
      return { ...InitialAppState };
    case LOGOUT_SUCCESS:
      return { ...InitialAppState, success_message: LOGOUT_SUCCESS_MESSAGE };
    case CLEAR_SUCCESS_MESSAGE:
      return { ...newState, success_message: "" };
    case CLEAR_ERROR_MESSAGE:
      return { ...newState, error: "", error_field: "" };
    case ACTION_503:
      return {
        ...newState,
        isServiceUnavailable: true,
        success_message: ACTION_503_MESSAGE,
      };
    default:
      return newState;
  }
};

type ContextState = {
  state: AppState;
  dispatch(action: Actions): void;
};

export const Context = React.createContext<ContextState>({
  state: InitialAppState,
  dispatch(_) {
    console.warn("Context.Provider外からの呼び出し");
  },
});
